


















































































































































// TODO utils or lodash
import StoriesItem from "~/stories_widget/models/StoriesItem"

import {Component, Emit, Inject, Prop, Vue, Watch} from "vue-property-decorator";
import StoriesSlider from "./StoriesSlider"
import StoriesSliderBlank from "./StoriesSliderBlank"
import {_winHeight, _winWidth} from '~/stories_widget/util/window-size';
import {animate} from '~/stories_widget/util/animation';
import {ReaderOptions, WidgetStoriesOptions} from "~/stories_widget/models/WidgetStoriesOptions";
import {Getter} from 'vuex-class';
import ArticleViewer from "~/stories_widget/components/Article/ArticleViewer";
import {debugLog} from "~/common_widget/common"
import {IssueArticleOptions} from "~/stories_widget/models/IssueArticle"
import {ArticleOptions} from "~/stories_widget/models/Article"

import {
    EVENT_ARTICLE_CLOSE,
    EVENT_ISSUE_ARTICLE_CLOSE,
    EVENT_STORIES_NEXT_SLIDE,
    EVENT_STORIES_TRANSITION_FROM_SLIDE,
    StoriesStatistic,
    TransitionFromSlideEvent
} from "../../StoriesStatistic";
import {NarrativeData, SendApiRequestConfig} from "~/stories_widget/models/NarrativeData"
import NarrativeContext from "~/stories_widget/models/NarrativeContext"

import BookmarkIcon from "~/stories_widget/components/svg/Bookmark.vue";
import BookmarkFilledIcon from "~/stories_widget/components/svg/BookmarkFilled.vue";
import ThumbsDownIcon from "~/stories_widget/components/svg/ThumbsDown.vue";
import ThumbsDownFilledIcon from "~/stories_widget/components/svg/ThumbsDownFilled.vue";
import ThumbsUpIcon from "~/stories_widget/components/svg/ThumbsUp.vue";
import ThumbsUpFilledIcon from "~/stories_widget/components/svg/ThumbsUpFilled.vue";
import ShareIcon from "~/stories_widget/components/svg/Share.vue";
import SoundOnIcon from "~/stories_widget/components/svg/SoundOn.vue";
import SoundOffIcon from "~/stories_widget/components/svg/SoundOff.vue";
import {debug} from "~/stories_widget/util/debug";
import {needSession} from "~/stories_widget/util/env";
import {STORY_LIST_TYPE} from "~/stories_widget/store/vuex-stories-module";
import GameReader from "~/stories_widget/components/GameReader/GameReader";
import {GameData} from "~/stories_widget/components/GameReader/GameReader.vue";
import SharePanel from "~/stories_widget/components/SharePanel/SharePanel.vue";

import {getOrientation, SCREEN_ORIENTATIONS} from "~/stories_widget/helpers/o9n.ts";
import ScreenOrientationLock from "~/stories_widget/components/Stories/StoriesViewer/ScreenOrientationLock.vue";
const orientation = getOrientation();

import isObject from "lodash/isObject"
import isFunction from "lodash/isFunction";
import {Method} from "axios";
// import isNumber from "lodash/isNumber"
// import isFinite from "lodash/isFinite"
// import _debounce from 'lodash/debounce'
// import Vue from 'vue'
// import {EventBus} from "../../../event-bus"

const sliderOptions = {
    speed: 350, // 350
    dragSpeedCoef: 1,
    easing: "linear",
    persMult: 1.6,
    allowDragDuringAnim: false
};

export interface BlankStoriesItem {
    blank: boolean
    id: number
}

const namespaceStories: string = 'stories';
const namespaceShared: string = 'shared';

@Component({
    name: "StoriesViewer",
    components: {
        ScreenOrientationLock,
        ArticleViewer,
        StoriesSlider,
        StoriesSliderBlank,
        BookmarkIcon,
        BookmarkFilledIcon,
        ThumbsUpIcon,
        ThumbsDownFilledIcon,
        ThumbsDownIcon,
        ThumbsUpFilledIcon,
        ShareIcon,
        SoundOnIcon,
        SoundOffIcon,
        GameReader,
        SharePanel
    }
})
export default class StoriesViewer extends Vue {

    /** property значения которые получает компонент */
    @Prop({type: Number}) id!: number; // story id for view
    @Prop({type: Boolean, default: false}) timerEnabled!: boolean;

    /** Component data */
    data() {
        return {
            activeStory: this.$store.getters['stories/storyId']
        }
    }

    gameReaderVisible: boolean = false;
    gameReaderData: Nullable<GameData> = null;

    articleViewerVisible: boolean = false;
    articleId: string = '';
    articleType: string = '';
    articleUid: string = '';

    activeSlide: number = 0;
    storyActiveSlide: Array<number> = [0];
    loaded: boolean = false;
    activeStory!: number;
    // displayedItems: Array<StoriesItem | BlankStoriesItem> = []; // todo - одновременно монтировать только 3 stories
    // displayedItemsIndexes: Array<number> = [];
    loadedItemsIndexes: Array<number> = [];
    anim: boolean = false;
    opened: boolean = false;
    leftSlideEl!: HTMLElement | null;
    centralSlideEl!: HTMLElement | null;
    rightSlideEl!: HTMLElement | null;

    sliderWidth: number = 0;
    perspective: number = 0;
    angle: number = 0;
    depth: number = 0;
    rotationTransform: string = '';
    rotationTransition: string = '';
    timerPaused: boolean = false;

    pausedUI: boolean = false;
    closeGestureInAction: boolean = false;
    swipeUpGestureInAction: boolean = false;

    readyForRendering: boolean = false;

    currentIndex: number = 1;

    private _timer!: number | null;

    private _html!: HTMLElement | null;
    private _body!: HTMLElement | HTMLBodyElement | null;
    private _globalWrapper!: HTMLElement | HTMLDivElement | null;
    private _slider!: Element | HTMLElement | HTMLDivElement | null;
    private _innerSlider!: HTMLElement | HTMLDivElement | null;
    private _backdrop!: HTMLElement | HTMLDivElement | null;

    private _progressBeforePause!: number;
    private _currentProgress!: number;
    private _pausedStory!: number | null;
    private _pausedSlide!: number | null;
    private _timerForceEnd!: boolean;

    private _rotating!: boolean;
    private _currentAngle!: number;

    private _pausedTimerId!: number | null;
    private _pausedUITimerId!: number | null;
    // private _sliderWidth!: number;

    private _statistic: StoriesStatistic | null = null;

    private defaultDuration = 10000;

    private _animationEndPromise!: null | Promise<number>;
    private _animationEndPromiseDelta!: null | number;

    needBottomPanel: boolean = false;
    slideStartEvent: boolean = false;
    slideStartEventLayerIndex: number|null = null;

    private _swipeUpLinkTarget: string|undefined = undefined;

    slideStart(layerIndex?: number) {
        debug('load - call slideStartEvent')
        this.slideStartEvent = true;
        this.$nextTick(() => this.slideStartEvent = false)
        if (layerIndex !== undefined) {
            this.$nextTick(() => {
                this.slideStartEventLayerIndex = layerIndex;
                this.$nextTick(() => this.slideStartEventLayerIndex = null)
            })
        }
    };

    /** Getters from vuex state */
    @Getter('modeDesktop', {namespace: namespaceStories}) desktopMode!: boolean;
    @Getter('activeSlideElementQuiz', {namespace: namespaceStories}) activeSlideElementQuiz!: any;
    @Getter('activeSlideElementQuizGrouped', {namespace: namespaceStories}) activeSlideElementQuizGrouped!: any;
    @Getter('activeSlideElementTest', {namespace: namespaceStories}) activeSlideElementTest!: any;
    @Getter('activeSlideElementQuest', {namespace: namespaceStories}) activeSlideElementQuest!: any;

    @Getter('transformStyle', {namespace: namespaceShared}) transformStyle!: string;
    @Getter('closeButtonPosition', {namespace: namespaceShared}) closeButtonPosition!: string;
    @Getter('readerOptions', {namespace: namespaceShared}) readerOptions!: ReaderOptions;
    @Getter('activeStories', {namespace: namespaceShared}) items!: Array<StoriesItem>;
    @Getter('items', {namespace: namespaceShared}) allStories!: Map<number, StoriesItem>;

    @Getter('hasLike', {namespace: namespaceShared}) sdkHasLike!: boolean;
    @Getter('hasFavorite', {namespace: namespaceShared}) sdkHasFavorite!: boolean;
    @Getter('hasShare', {namespace: namespaceShared}) sessionHasShare!: boolean;

    @Getter('muted', {namespace: namespaceStories}) muted!: boolean;
    @Getter('sliderWidth', {namespace: namespaceStories}) _sliderWidth!: Nullable<number>;


    /** Computed */

    get rootVars(): object {
        return {
            '--loaderBackgroundColor': this.readerOptions.loader.default.color,
            '--loaderBackgroundAccentColor': this.readerOptions.loader.default.accentColor,
        };
    }

    private displayedItemIds: Array<number> = [];
    createDisplayedItems() {
        // нужно чтобы при снятии состояния favorite - список не менялся
        this.displayedItemIds = this.items.map(item => item.id);
    }

    get displayedItems(): Array<StoriesItem | BlankStoriesItem> {
        // https://www.typescriptlang.org/docs/handbook/advanced-types.html#user-defined-type-guards
        const isStories = (item: StoriesItem | BlankStoriesItem | undefined): item is (StoriesItem | BlankStoriesItem) => {
            return !!item
        }
        return [
            {blank: true, id: -1},
            ...this.displayedItemIds.map(id => this.allStories.get(id)).filter(_ => _) as Array<StoriesItem | BlankStoriesItem>,
            {blank: true, id: -2}
        ];
    }

    get displayedItemsIndexes(): Array<number> {
        return this.displayedItems.map((item: StoriesItem | BlankStoriesItem) => item.id);
    }

    get currentStory(): StoriesItem | undefined {
        return this.$store.getters['shared/items'].get(this.id);
    }

    get activeStoryIndex() {
        return this.fetchStoryIndex(this.id)
    }

    get prevStoryBlank() {
        return this.displayedItems[this.currentIndex - 1] === undefined || this.isBlankStories(this.displayedItems[this.currentIndex - 1])
    }

    get nextStoryBlank() {
        return this.displayedItems[this.currentIndex + 1] === undefined || this.isBlankStories(this.displayedItems[this.currentIndex + 1])
    }

    get timeout() {
        return this.fetchSlideDuration()
    }

    get desktopBtnPrevPosition() {
        let width = 0;
        if (this.desktopMode) {
            width = parseFloat(this.storiesSlideWidth(this.currentStory));
        } else {
            width = _winWidth();
        }
        return `translateY(-50%) translateX(calc(-${width / 2}px - 200%))`;
    }

    get desktopBtnNextPosition() {
        let width = 0;
        if (this.desktopMode) {
            width = parseFloat(this.storiesSlideWidth(this.currentStory));
        } else {
            width = _winWidth();
        }
        return `translateY(-50%) translateX(calc(${width / 2}px + 100%))`;
    }

    get displayedSlideImage(): Nullable<string> {
        let story = this.displayedItems[this.currentIndex];
        if (story && !this.isBlankStories(story) && story instanceof StoriesItem) {
            return story.imagePerSlide(this.storyActiveSlide[this.currentIndex]);
        }
        return null;
    }

    hasLike(story: StoriesItem | BlankStoriesItem): boolean {
        if (story instanceof StoriesItem) {
            if (!story.like_functional) {
                return false;
            }
            return this.sdkHasLike;
        }
        return false;
    }

    hasShare(story: StoriesItem | BlankStoriesItem): boolean {
        if (story instanceof StoriesItem) {
            if (!story.share_functional) {
                return false;
            }
            return this.sessionHasShare;
        }
        return false;
    }

    hasFavorite(story: StoriesItem | BlankStoriesItem): boolean {
        if (story instanceof StoriesItem) {
            if (!story.favorite_functional) {
                return false;
            }
            return this.sdkHasFavorite;
        }
        return false;
    }
    hasAudio(story: StoriesItem | BlankStoriesItem): boolean {
        if (story instanceof StoriesItem) {
            if (story.has_audio) {
                return true;
            }
        }
        return false;
    }


    @Inject('setVisible') setVisible!: Function;
    @Inject('setHidden') setHidden!: Function;

    // @Provide('timerPaused')
    // resumeAndEnableViewerUI(): void {
    //     this.timerPaused = true;
    //     this.pausedUI = true;
    // }

    /** Methods */

    storiesSlideTransform(index: number) {
        if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
            return {transform: `translateZ(0)`, transition: 'inherit'};
        } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {
            return {transform: `translateZ(0) scale(1)`, transition: 'inherit'};
        } else {
            // cube
            return {transform: 'rotateY(' + (index * this.angle) + `deg) translateZ(${this.depth}px)`};
        }
    }

    lockVerticalScroll(): void {
        // if ((<any>window).WStories) {
        //     (<any>window).WStories.switchToFullScreen();
        // }
        return;
        /*        if (this._body !== null) {
                    this._body.style.setProperty('user-select', 'none')
                    this._body.style.setProperty('-webkit-user-select', 'none')
                }

                if (this._globalWrapper !== null) {
                    this._globalWrapper.style.setProperty('overflow', 'hidden');
                }

                if (this._body !== null) {
                    this._body.style.setProperty('overflow', 'hidden');
                    this._body.style.setProperty('-webkit-overflow-scrolling', 'touch');
                }
                if (this._html) {
                    this._html.style.setProperty('position', 'fixed');
                    this._html.style.setProperty('overflow', 'hidden');
                }*/
    }

    unlockVerticalScroll(): void {
        // if ((<any>window).WStories) {
        //     (<any>window).WStories.switchFromFullScreen();
        // }
        return;
        /*        if (this._body !== null) {
                    this._body.style.setProperty('user-select', '')
                    this._body.style.setProperty('-webkit-user-select', '') // todo ios перенести в reader
                }

                  if (this._globalWrapper) {
                      this._globalWrapper.style['overflow'] = ''
                  }
                  if (this._body !== null) {
                      this._body.style.setProperty('overflow', '')
                      this._body.style.setProperty('-webkit-overflow-scrolling', '')
                  }
                  if (this._html !== null) {
                      this._html.style.setProperty('position', '')
                      this._html.style.setProperty('overflow', '')
                  }*/

    }

    removeAllEventListeners(): void {

        window.removeEventListener('resize', this.init3DSlider);
        window.removeEventListener('resize', this.initSlidesAspectRatio);

        if (this._slider !== null) {

            /* Feature detection */
            let passiveSupported = false;
            try {

                window.addEventListener(
                    "abort",
                    _ => _,
                    Object.defineProperty({}, "passive", {
                        get: function () {
                            passiveSupported = true;
                        }
                    }) as EventListenerOptions);
            } catch (err) {
            }

            this._slider.removeEventListener('mousedown', this.dragRotationHandler);
            this._slider.removeEventListener('touchstart', this.dragRotationHandler, passiveSupported ? {passive : true} as EventListenerOptions : false)
        }

        const rotater: HTMLElement = (<HTMLElement>this.$refs.rotater);

        if (rotater !== null) {
            rotater.removeEventListener('transitionend', this.onTransitionEnd);
        }

        (<any>orientation).removeEventListener('change', this.checkScreenOrientation);

    }

    updateDisplayedItems(count?: number): void {

        this.$nextTick(() => {
            this.refreshSlidesLinks();
        });

        // this.currentIndex++;

        return;

        let items: Array<StoriesItem> = this.$store.getters['shared/loadedStories'];
        let displayedItems: Array<StoriesItem | BlankStoriesItem> = [];
        let displayedItemsIndexes: Array<number> = [];

        const storyId = this.$store.getters['stories/storyId'];

        debug(`updateDisplayedItems storyId:${storyId}`);

        const indexInItems = this.$store.getters['shared/activeStoriesIds'].indexOf(storyId);
        // debug(`indexInItems ${this.$store.getters.activeStoriesIds.indexOf(storyId)}`, items, this.$store.getters.activeStoriesIds)

        if (indexInItems !== -1) {

            if (indexInItems === 0 || items[indexInItems - 1] === undefined) {
                displayedItems[0] = {
                    blank: true,
                    id: -1,
                }
            } else {
                displayedItems[0] = items[indexInItems - 1];
            }

            displayedItems[1] = items[indexInItems];

            if (indexInItems === items.length - 1 || items[indexInItems + 1] === undefined) {
                displayedItems[2] = {
                    blank: true,
                    id: -2,
                }
            } else {
                displayedItems[2] = items[indexInItems + 1];
            }

            displayedItems.forEach((item) => {
                if (item) {
                    displayedItemsIndexes.push(item.id);
                }
            })
        }

        // this.displayedItems = displayedItems;
        this.$nextTick(() => {
            this.refreshSlidesLinks();
        });


        // debug(`updated items for storyId ${storyId}`)
        debug(displayedItems);


        // this.displayedItemsIndexes = displayedItemsIndexes;

        let loadedItemsIndexes: Array<number> = [];
        items.forEach((item, index) => {
            if (item) {
                loadedItemsIndexes[index] = item.id;
            }
        });

        this.loadedItemsIndexes = loadedItemsIndexes;

    }

    initStoriesStyle(): void {
        const id = 'stories-slider-style';
        let style: HTMLElement | null = document.getElementById(id);
        let css = '';
        let storiesContext: NarrativeContext | null = this.$store.getters['stories/storiesContext'];
        if (storiesContext !== null) {
            css = storiesContext.style;
        }

        if (style === null) {
            style = document.createElement("style");
            (<HTMLStyleElement>style).type = 'text/css';
            style.id = id;
            style.attributes.setNamedItem(document.createAttribute('scoped'));

            if ((<any>style).styleSheet) {
                (<any>style).styleSheet.cssText = css
            } else {
                style.appendChild(document.createTextNode(css))
            }
            this.$el.appendChild(style)
        } else {
            if ((<any>style).styleSheet) {
                (<any>style).styleSheet.cssText = css
            } else {
                style.textContent = '';
                style.appendChild(document.createTextNode(css))
            }
        }


    }

    initStoriesScript(): void {
        // выполняем если еще не был запущен в контектсе этого окна
        // предотвращаем переписывание narrative_saved_data при повторном открытии ридера
        if (!("_narrative_common" in window)) {
            try {
                let script = '';
                let storiesContext: NarrativeContext | null = this.$store.getters['stories/storiesContext'];
                if (storiesContext !== null) {
                    script = storiesContext.script;
                }

                if (script.length > 0) {
                    let F = new Function(script);
                    F();
                }
            } catch (e) {
                console.error(e);
            }
        }
    }

    // TODO вынести через композицию, а то слишком много кода
    initDataFeature() {

        (<any>window).isWeb = true;
        const self = this;

            (<any>window)._getNarrativeLocalData = function () {
                if ((<any>window).__activeNarrativeId !== undefined) {
                    let localData = sessionStorage.getItem('narrative_' + (<any>window).__activeNarrativeId + '_data'); // user_id (реализуется через сессию)
                    if (localData) {
                        return JSON.parse(localData);
                    }
                }
                return {};
            };

            (<any>window)._setNarrativeLocalData = function (keyValue: any, sendToServer?: boolean) {
                if ((<any>window).__activeNarrativeId !== undefined) {
                    let data = JSON.stringify(keyValue);
                    sessionStorage.setItem('narrative_' + (<any>window).__activeNarrativeId + '_data', data);

                    if (sendToServer) {
                        if (needSession()) {
                            NarrativeData.sentData((<any>window).__activeNarrativeId, {'data': data});
                        }
                    }

                }
            };

            (<any>window)._sendNarrativeData = function (keyValue: string) {
                if ((<any>window).__activeNarrativeId !== undefined) {
                    NarrativeData.sentData((<any>window).__activeNarrativeId, {'data': JSON.stringify(keyValue)});
                }
            };

            (<any>window)._showNarrativeSlide = function (index: number, layerIndex?: number) {
                // with slide index ?
                self.__afterStartInitQueuePush(() => {
                    self.toSlide(index, {renewTimer: true}, layerIndex)
                });
            };

            (<any>window)._showNarrativeNextSlide = function (delay: string) {
                self.__afterStartInitQueuePush(() => {

                    self.stopTimer();
                    if (delay) {
                        self.setTimer({
                            remainingTimeout: parseInt(delay) || 0,
                            clearProgressBeforePause: true,
                            forceStartTimer: true,
                            isAutoTransition: false
                        });
                    } else {
                        self.nextSlide({renewTimer: true, isAutoTransition: false});
                    }

                });



            };

            (<any>window)._showNextStoryExists = true;
            (<any>window)._storyShowPrev = function () {
                self.stopTimer();
                // slide to the next story
                self.nextStory(-1);
            };

            (<any>window)._storyShowNext = function () {
                self.stopTimer();
                // slide to the next story
                self.nextStory(1);
            };


            (<any>window)._showNarrativeTextInput = function (id: string, config: any) {
                let title = '';
                let _default = '';
                try {
                    title = config.text.value;
                    _default = config.input.text.value;
                } catch (e) {
                    console.error(e);
                }

                let userText = prompt(title, _default);

                if ("narrative_send_text_input_result" in window) {
                    (<any>window).narrative_send_text_input_result(id, userText);
                }

            };


            (<any>window).narrative_send_text_input_result = function (id: string, text: string | null | undefined) {
                if ("_narrative_data_input" in window && (<any>window)._narrative_data_input_element && (<any>window)._narrative_data_input_element.length) {
                    (<any>window)._narrative_data_input.setUserData(id, text);
                }
                if ("_narrative_poll" in window && (<any>window)._narrative_poll_element) {
                    (<any>window)._narrative_poll.setUserData(id, text);
                }
                if ("_narrative_rate" in window && (<any>window)._narrative_rate_element && (<any>window)._narrative_rate_element.length) {
                    (<any>window)._narrative_rate.setUserData(id, text);
                }
            };

            (<any>window)._showNarrativeLink = function (target: string) {

                if (target) {

                    let event: { storyId: number, transitionToType: string, transitionToId: number } = {
                        storyId: this.$store.getters['stories/storyId'],
                        transitionToType: '',
                        transitionToId: 0
                    };

                    this.$emit('transitionFromSlide', event);

                    // TODO overload
                    /** External url **/
                    window.open(target, '_parent');
                }
                return true;
            };

            (<any>window)._openGameReader = function (gameFile: string, coverFile: string, gameConfig: string, addResources: string) {
                self.pauseAndBlockReaderUIForGameReader({gameFile, coverFile, gameConfig, addResources});
                return true;
            };

            (<any>window)._sendApiRequest = function (url: string, method: Method, params: Nullable<Dict<any>>, headers: Nullable<Dict<any>>, data: Nullable<Dict<any>>, profilingKey?: string) {
                return NarrativeData.sendApiRequest({url, method, params, headers, data});
            };

            (<any>window)._sendApiRequestSupported = true;


            const widgetShare = (id: string, config: {url: string}) => {

                const sharePath = config?.url;

                const openSharePanel = () => {
                    this.shareLink = sharePath;
                    this.sharePanelOpen = true;
                    this.shareId = id;
                }

                const pauseUI = () => {
                    this.timerPaused = true;
                    this.pausedUI = true;
                }
                const resumeUI = () => {
                    this.timerPaused = false;
                    this.pausedUI = false;
                }

                if (this.desktopMode || !(<any>navigator).share) {
                    openSharePanel();
                    pauseUI();
                } else {
                    try {
                        (<any>navigator).share({
                            url: sharePath,
                        })
                            .then(() => {
                                resumeUI();
                                (<any>window).share_complete(id, true);
                            })
                            .catch((error: any) => {
                                resumeUI();
                                (<any>window).share_complete(id, false);
                            });

                        pauseUI();

                    } catch (e) {
                        // navigator.share есть но не срабатывает на win 7 например
                        openSharePanel();
                        pauseUI();
                    }
                }

            };
            (<any>window)._share = (id: string, config: {url: string}) => widgetShare(id, config);

            (<any>window).share_complete = function (id: string, isSuccess: boolean) {
                if ((<any>window)._narrative_share) {
                    (<any>window)._narrative_share.complete(id, isSuccess);
                }
            };

    }

    slideClick(event: Event): void | boolean {

        if (this.pausedUI) {
            return
        }

        if (this._rotating) {
            return
        }

        let continueClick: boolean = true;

        const target = event.target;
        let url: string | null = null;
        let type = null;
        let id: any = '';
        let requireCustomAction = false;

        if (target && (<HTMLElement>target).classList.contains('narrative-element-link')) {
            const dataSet = (<HTMLElement>target).dataset;
            type = dataSet.linkType;
            if (dataSet.linkType === 'article' && dataSet.linkTarget) {
                id = dataSet.linkTarget;
                url = id;
                // url = `article/${dataSet.linkTarget}`;
                // const parsedId = parseInt(dataSet.linkTarget);
                // if (isNumber(parsedId) && isFinite(parsedId)) {
                //     id = parsedId;
                // }
                // if (dataSet.articleSlug) {
                //     url = `article/${dataSet.articleSlug}`;
                //     id = dataSet.articleSlug;
                // }
            } else if (dataSet.linkType === 'issue-article' && dataSet.linkTarget) {
                id = dataSet.linkTarget;
                url = id;
                // url = `article/${dataSet.magazineId || 0}/${dataSet.linkTarget}`;
                // const parsedId = parseInt(dataSet.linkTarget);
                // if (isNumber(parsedId) && isFinite(parsedId)) {
                //     id = parsedId;
                // }
                // if (dataSet.issueArticleSlug && dataSet.magazineSlug) {
                //     url = `article/${dataSet.magazineSlug}/${dataSet.issueArticleSlug}`;
                //     id = dataSet.issueArticleSlug;
                // }
            } else if (dataSet.linkType === 'url') {
                /** External link - open direct */
                url = (<string>dataSet.linkTarget);
            } else if (dataSet.linkType === 'customAction') {
                /** Custom action */
                requireCustomAction = true;
                url = (<string>dataSet.linkTarget);
            } else if (dataSet.linkType === 'slide') {

                let story = this.displayedItems[this.currentIndex];
                if (!this.isBlankStories(story) && story instanceof StoriesItem && dataSet.linkTarget !== undefined) {
                    const __slideIndex = parseInt(dataSet.linkTarget);
                    const __slideCount = story.slides_count;
                    if (__slideCount !== null && __slideIndex >= 0 && __slideIndex < __slideCount) {
                        (<any>window)._showNarrativeSlide(__slideIndex, 0);
                        return true;
                    }
                }



            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-image')) {
            const dataSet = (<HTMLElement>target).dataset;
                /** External link - open direct */
                if (<string>dataSet.linkTarget) {
                    url = <string>dataSet.linkTarget;
                    type = 'url';
                }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-swipe-up')) {
            const dataSet = (<HTMLElement>target).dataset;
                /** External link - open direct */
                if (<string>dataSet.linkTarget) {
                    url = <string>dataSet.linkTarget;
                    type = 'url';
                }
        } else if (target && ((<HTMLElement>target).classList.contains('narrative-element-quiz-next-button')
            || (<HTMLElement>target).classList.contains('narrative-element-test-next-button'))) {

            if ("_showNarrativeNextSlide" in window) {
                (<any>window)._showNarrativeNextSlide(0);
                return;
            }

        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-quiz-answer')) {
            if ((<HTMLElement>target).closest('.narrative-element-quiz')) {
                /* quiz */
                if ("_narrative_quiz" in window) {
                    continueClick = (<any>window)._narrative_quiz.select(target);
                    continueClick = false;  // по клику на варианты ответа(даже на законченной викторине) не делаем клик на слайде
                }
            } else if ((<HTMLElement>target).closest('.narrative-element-quiz-grouped')) {
                /* quiz-grouped */
                if ("_narrative_quiz_grouped" in window) {
                    continueClick = (<any>window)._narrative_quiz_grouped.select(target);
                    continueClick = false;  // по клику на варианты ответа(даже на законченной викторине) не делаем клик на слайде
                }
            }
            // расширенная область клика на весь виджет - для неточных снайперов
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-data-input')) {

            /* _narrative_data_input */
            if ("_narrative_data_input" in window) {
                (<any>window)._narrative_data_input.click(target);

                continueClick = false;
            }

        } else if (target && ((<HTMLElement>target).classList.contains('rangeslider') || (<HTMLElement>target).closest('.rangeslider'))) {
            /** Range slider */
            continueClick = false;
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-range-slider-next-button')) {
            /** Range slider complete button */

            if ("_narrative_range_slider" in window) {
                continueClick = (<any>window)._narrative_range_slider.click(target);
            }

        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-poll-button')) {

            /* _narrative_poll or _narrative_poll_layers */
            if ((<any>window)._narrative_poll_element) {
                if ("_narrative_poll" in window) {
                    (<any>window)._narrative_poll.select(target);
                    continueClick = false;
                }
            }
            if ((<any>window)._narrative_poll_layers_element) {
                if ("_narrative_poll_layers" in window) {
                    (<any>window)._narrative_poll_layers.select(target);
                    continueClick = false;
                }
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-vote-answer')) {

            /* _narrative_vote */
            if ("_narrative_vote" in window) {
                (<any>window)._narrative_vote.select(target);
                continueClick = false;
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-rate-input')) {

            /* _narrative_rate */
            if ("_narrative_rate" in window) {
                (<any>window)._narrative_rate.select(target);
                continueClick = false;
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-test-answer')) {
            if ((<HTMLElement>target).closest('.narrative-element-test')) {
                /* test */
                if ("_narrative_test" in window) {
                    continueClick = (<any>window)._narrative_test.select(target);
                    continueClick = false;  // по клику на варианты ответа(даже на законченном тесте) не делаем клик на слайде
                }

            } else if ((<HTMLElement>target).closest('.narrative-element-quest')) {
                /* quest */
                if ("_narrative_quest" in window) {
                    continueClick = (<any>window)._narrative_quest.select(target);
                    continueClick = false;  // по клику на варианты ответа(даже на законченной викторине) не делаем клик на слайде
                }
            }
            // расширенная область клика на весь виджет - для неточных снайперов
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-test-answer')) {
            /* test */
            if ("_narrative_test" in window) {
                continueClick = (<any>window)._narrative_test.select(target);
                continueClick = false;  // по клику на варианты ответа(даже на законченном тесте) не делаем клик на слайде
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-copy')) {
            /* copy */
            if ("_narrative_copy" in window) {
                continueClick = (<any>window)._narrative_copy.click(target);
                continueClick = false;
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-share')) {
            /* copy */
            if ("_narrative_share" in window) {
                continueClick = (<any>window)._narrative_share.click(target);
                continueClick = false;
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-game')) {
            if ("_narrative_game" in window) {
                continueClick = (<any>window)._narrative_game.click(target);
                continueClick = false;
            }
        } else if (target && (<HTMLElement>target).classList.contains('narrative-element-story-repeat')) {

            let savedData = {};

            // не удаляем счетчик повторов из игры cat trap

            let data = (<any>window)._getNarrativeLocalData();
            if (('_narrative_saved_data' in (<any>window)) && (<any>window)._narrative_saved_data[(<any>window).__activeNarrativeId] !== undefined && isObject((<any>window)._narrative_saved_data[(<any>window).__activeNarrativeId])) {
                data = Object.assign({}, (<any>window)._narrative_saved_data[(<any>window).__activeNarrativeId], data);
            }

            for (var key in data) {
                if (data.hasOwnProperty(key)) {
                    if (/^_gm_[A-z0-9-_]+_attempts$/.test(key)) {
                        //@ts-ignore
                        savedData[key] = data[key];
                    }
                }
            }

            if (('_narrative_saved_data' in (<any>window)) && (<any>window)._narrative_saved_data[(<any>window).__activeNarrativeId] !== undefined && isObject((<any>window)._narrative_saved_data[(<any>window).__activeNarrativeId])) {
                (<any>window)._narrative_saved_data[(<any>window).__activeNarrativeId] = savedData;
            }


            (<any>window)._setNarrativeLocalData(savedData, true);
            (<any>window)._showNarrativeSlide(0, 0);

            continueClick = false;
        } else if (target && (<HTMLElement>target).classList.contains('button-panel-action')) {
            let classList: DOMTokenList = (<HTMLElement>target).classList;
            let currentItem: StoriesItem|BlankStoriesItem|undefined = this.displayedItems[this.currentIndex];

            if (currentItem !== undefined && currentItem instanceof StoriesItem) {
                if (classList.contains('like-up')) {
                    this.setLike(currentItem, 1);
                } else if (classList.contains('like-up-filled')) {
                    this.setLike(currentItem, 0);
                } else if (classList.contains('like-down')) {
                    this.setDislike(currentItem, -1);
                }  else if (classList.contains('like-down-filled')) {
                    this.setDislike(currentItem, 0);
                } else if (classList.contains('bookmark')) {
                    this.setBookmark(currentItem, 1);
                } else if (classList.contains('bookmark-filled')) {
                    this.setBookmark(currentItem, 0);
                } else if (classList.contains('share')) {
                    this.actionShare(currentItem);
                } else if (classList.contains('sound-icon')) {
                    this.onMute();
                } else if (classList.contains('muted-icon')) {
                    this.onUnmute();
                }


                continueClick = false;
            }

        }

        if (url !== null) {

            continueClick = false;

            let event: { storyId: number, transitionToType: string, transitionToId: number } = {
                storyId: this.$store.getters['stories/storyId'],
                transitionToType: '',
                transitionToId: 0
            };
            if (type === 'article') {
                event.transitionToType = ArticleOptions.TYPE;
                event.transitionToId = parseInt(id);
            } else if (type === 'issue-article') {
                event.transitionToType = IssueArticleOptions.TYPE;
                event.transitionToId = parseInt(id);
            }

            this.$emit('transitionFromSlide', event);

            /** External url **/
            if (type === 'url') {

                // pass event to parent widget (with overload fn)

                this.$emit('clickOnButton', {id: this.$store.getters['stories/storyId'], index: this.storyActiveSlide[this.currentIndex], url})

                // window.open(url, '_parent');

                // window.open(url, '_blank');
            } else {

                if (type === 'article') {
                    this.articleId = id;
                    this.articleType = ArticleOptions.TYPE;
                    this.articleUid = type + (<string>id);

                    this.pauseAndBlockViewerUIForArticleViewer();

                } else if (type === 'issue-article') {
                    this.articleId = id;
                    this.articleType = IssueArticleOptions.TYPE;
                    this.articleUid = type + (<string>id);

                    this.pauseAndBlockViewerUIForArticleViewer();

                } else {
                    debugLog(`unsupported type ${type}`);
                }

            }

        }




        if (!continueClick) {
            return;
        }

        /** can tap to next slide */
        let quizElement = this.activeSlideElementQuiz;
        if (quizElement && ("_narrative_quiz" in window)) {
            continueClick = (<any>window)._narrative_quiz.slideQuizIsDone(quizElement);
        }

        /** can tap to next slide */
        let quizGroupedElement = this.activeSlideElementQuizGrouped;
        if (quizGroupedElement && ("_narrative_quiz_grouped" in window)) {
            continueClick = (<any>window)._narrative_quiz_grouped.slideQuizIsDone(quizGroupedElement);
        }


        /** can tap to next slide */
        let testElement = this.activeSlideElementTest;
        if (testElement && ("_narrative_test" in window)) {
            continueClick = (<any>window)._narrative_test.slideTestIsDone(testElement);

            // TODO  роутинг кликов перенаправить в виджеты
            if ((<any>window)._narrative_test.slideTestWithTimer(testElement) && !continueClick) {
                return; // disable all clicks
            }
        }

        let width = 0,
            xCoord = 0;
        if (this.desktopMode) {
            width = parseFloat(this.storiesSlideWidth(this.currentStory));
            xCoord = (<MouseEvent>event).offsetX;
        } else {
            width = _winWidth();
            xCoord = (<any>event).pageX || ((<TouchEvent>event).touches && (<TouchEvent>event).touches[0].pageX);
        }

        const xPercent = xCoord / width;

        const _clickNext = (_continueClick: boolean, _xPercent: number) => {
            if (_xPercent <= .3) {
                this.prevSlide({renewTimer: true})
            } else {
                if (!_continueClick) {
                    return;
                }
                this.nextSlide({renewTimer: true, isAutoTransition: false})
            }
        }

        /** can tap to next slide */
        let questElement = this.activeSlideElementQuest;
        if (questElement && ("_narrative_quest" in window)) {

            let story = this.displayedItems[this.currentIndex];
            if (!this.isBlankStories(story) && story instanceof StoriesItem) {
                const slideIndex = this.storyActiveSlide[this.currentIndex];
                const slideCount = story.slides_count;
                (<any>window)._narrative_quest.handleRouteClick(questElement, {
                    direction: xPercent >= .3 ? 'forward' : 'backward',
                    slideIndex: slideIndex,
                    slideCount: slideCount,
                    click: () => _clickNext(continueClick, xPercent),
                });
                return;
            }
        }

        _clickNext(continueClick, xPercent);

    };

    hideViewer(): void {
        this.timerPaused = true;
        this.setHidden();
        if (this._backdrop !== null) {
            this._backdrop.style.setProperty('display', 'none');
        }
        this.unlockVerticalScroll();
        this.$emit('hideViewer')
    }

    showViewerAfterHide(): void {
        this.timerPaused = false;
        // this.init3DSlider()

        this.setVisible();
        if (this._backdrop !== null) {
            this._backdrop.style.setProperty('display', '')
        }
        this.lockVerticalScroll();
        this.$emit('showViewerAfterHide')
    }

    closeViewer(): void {
        let currentItem: StoriesItem|BlankStoriesItem|undefined = this.displayedItems[this.currentIndex];
        let disable_close = false;
        if (!this.isBlankStories(currentItem) && currentItem instanceof StoriesItem) {
            disable_close = currentItem.disable_close;
        }
        if (disable_close) {
            return;
        }
        this.closeViewerImportant();
    };

    closeViewerImportant(): void {
        if (this._timer) {
            this._timerForceEnd = true;
            clearTimeout(this._timer)
        }
        this.$store.commit('stories/setNextFlippingStory', null);
        // после закртыия скидываем тип списка в default ``
        this.$store.commit('shared/setStoryListType', {type: STORY_LIST_TYPE.default});
        this.$emit('close');
        this.$emit('closeStory', {id: this.$store.getters['stories/storyId']});
    };

    onPause(): void {
        // save paused story and slide
        this.stopTimer();
        this._progressBeforePause = this._currentProgress;
        this._pausedStory = this.activeStory;
        this._pausedSlide = this.storyActiveSlide[this.currentIndex]
        debug(`onPause: t--${this.timeout * this._progressBeforePause} p--${this._progressBeforePause * 100}%`)
    }

    onResume(): void {
        // check paused slide and story
        this.pausedUI = false;

        if (this._pausedStory === this.activeStory && this._pausedSlide === this.storyActiveSlide[this.currentIndex]) {
            let remainingProgress = 1 - this._progressBeforePause;
            let remainingTimeout = this.timeout * remainingProgress;
            debug(`onResume: timeoutT--${this.timeout} remainingT--${remainingTimeout} remainingP--${remainingProgress * 100}%`)
            this.setTimer({remainingTimeout, clearProgressBeforePause: false})

        } else {
            // debug(`on resume with another slide or story`)
        }
    }

    setTimer({
                 remainingTimeout,
                 clearProgressBeforePause,
                 forceStartTimer,
                 isAutoTransition,
             }: { remainingTimeout: number, clearProgressBeforePause: boolean, forceStartTimer?: boolean, isAutoTransition?: boolean } = {
        remainingTimeout: this.timeout,
        clearProgressBeforePause: true,
        forceStartTimer: false,
        isAutoTransition: true,
    }) {

        if (this._timer !== null) {
            clearTimeout(this._timer)
        }
        this._timer = null;
        if ((this.timerEnabled || forceStartTimer) && remainingTimeout > 0) {
            debug(`timer ${forceStartTimer} ${remainingTimeout}`, this.$store.getters['stories/storyId'], this.currentIndex, this.storyActiveSlide[this.currentIndex])

            if (this._timerForceEnd === true) {
                this._timerForceEnd = false
            }

            // для анимации перехода, чтобы не увеличивать ее скорость + используем startProgress
            let defaultDuration = this.timeout || this.defaultDuration;

            if (forceStartTimer) {
                defaultDuration = remainingTimeout;
            }

            this._timer = setTimeout(() => this.nextSlide({renewTimer: false, isAutoTransition: Boolean(isAutoTransition)}), remainingTimeout);

            // try {
            //   this._slideTick = this.$children[1].$children[0].$refs.tick[this.storyActiveSlide[this.currentIndex]]
            // } catch (e) {
            //   this._slideTick = null
            // }
            // debug(this.$children[1], this.$children)
            // debug(this.storyActiveSlide, this.currentIndex)
            // debug(this._slideTick)

            // start progress bar
            this._currentProgress = 0;
            if (clearProgressBeforePause) {
                this._progressBeforePause = 0;
            }

            animate({
                duration: defaultDuration,
                timing: (timeFraction) => timeFraction,
                draw: (progress) => {
                    const rotater: HTMLElement = (<HTMLElement>this.$refs.rotater);
                    if (rotater !== null) {
                        rotater.style.setProperty('--tick', (this._progressBeforePause + progress) * 100 + '%');
                        this._currentProgress = this._progressBeforePause + progress;
                        if (progress === 1) {
                            this.$nextTick(() => {
                                if (this._currentProgress === 0) {
                                    rotater.style.setProperty('--tick', '0%');
                                    // this._currentProgress = 0;
                                }
                            });
                        }
                    }
                },
                paused: () => this.timerPaused,
                forceEnd: () => this._timerForceEnd,
            })
        } else if (remainingTimeout === 0) {
            this._timerForceEnd = true
        }
    }

    stopTimer(): void {
        if (this._timer !== null) {
            this._timerForceEnd = true;
            clearTimeout(this._timer)
        }
    }

    nextSlide({renewTimer, isAutoTransition} = {renewTimer: false, isAutoTransition: false}): void {

        let slides = [];
        if (this.currentStory !== undefined) {
            slides = this.currentStory.slides_html;
        }

        const storyIndex = this.currentIndex;
        // if (this.storyActiveSlide[storyIndex] === undefined) {
        //   this.$set(this.storyActiveSlide, storyIndex, 0)
        // }

        debug(`nextSlide call storyIndex: ${storyIndex}`);

        this._progressBeforePause = 0;
        this.pausedUI = false;

        if (this.storyActiveSlide[storyIndex] === (slides.length - 1)) {
            this.stopTimer();
            // slide to the next story

            debug('slide to the next story');

            this.nextStory(1, isAutoTransition);

        } else {
            debug(`slide to the next story else storyIndex: ${storyIndex} this.storyActiveSlide[storyIndex]: ${this.storyActiveSlide[storyIndex]} (slides.length - 1): ${(slides.length - 1)}`);
            this.toSlide(this.storyActiveSlide[storyIndex] + 1, {renewTimer})

        }
    }

    prevSlide({renewTimer} = {renewTimer: false}): void {
        const storyIndex = this.currentIndex;

        this._progressBeforePause = 0;
        this.pausedUI = false;

        if (this.storyActiveSlide[storyIndex] === 0) {
            this.stopTimer();
            // slide to the next story

            this.nextStory(-1);

        } else {
            this.toSlide(this.storyActiveSlide[storyIndex] - 1, {renewTimer});
        }

    }

    toSlide(index: number, {renewTimer} = {renewTimer: false}, layerIndex?: number): void {

        const storyIndex = this.currentIndex;
        const currentStoryId = this.$store.getters['stories/storyId'];
        const currentSlideIndex = this.storyActiveSlide[storyIndex];
        const sameSlide = currentSlideIndex === index;
        this.$set(this.storyActiveSlide, storyIndex, index);

        if (renewTimer) {
            this.stopTimer()
        }

        const cb = () => {
            debug('timer - prev/next slide')
            this.setTimer();
            this.slideStart(layerIndex);
            this.$emit('nextSlide', {fromStoryId: currentStoryId, fromSlideIndex: currentSlideIndex})
            this.$emit('showSlide', {id: currentStoryId, index});
        };

        if (sameSlide) {
            debug('SAME SLIDE');
            cb();
        } else {
            // if slide index changed
            this.waitForSlideLoaded(currentStoryId).then((result) => {
                if (result) {
                    cb();
                } else {
                    debug(`slide don\`t loaded: ${currentStoryId}`)
                }
            });
        }
    }

    fetchSlideDuration(): number {
        const slidesDuration = this.$store.getters['shared/items'].get(this.$store.getters['stories/storyId'] || this.id) !== undefined ? this.$store.getters['shared/items'].get(this.$store.getters['stories/storyId'] || this.id)?.slides_duration : [];
        const index = this.storyActiveSlide[this.currentIndex] !== undefined ? this.storyActiveSlide[this.currentIndex] : 0;

        if (slidesDuration !== undefined) {
            if (slidesDuration[index] === 0) {
                return 0
            }
            return slidesDuration[index] || this.defaultDuration
        }
        return this.defaultDuration;
    }

    fetchStoryIndex(id: number): number {
        return this.displayedItemsIndexes.indexOf(id)
    }

    fetchStoryIndexInLoaded(id: number): number {
        return this.loadedItemsIndexes.indexOf(id)
    }

    activateStoryAfterSwipe(rotatedCnt: number, slideLoadPromise: Nullable<Promise<boolean>>): void {
        if (rotatedCnt !== 0) {

                const currentStoryIndex = this.currentIndex;
            let nextStoryIndex = -1,
                nextStoryId: number|undefined;

            nextStoryIndex = currentStoryIndex + rotatedCnt;
            if (nextStoryIndex >= this.displayedItems.length) { // не должно быть
                nextStoryIndex = nextStoryIndex - this.displayedItems.length
            } else if (nextStoryIndex < 0) { // не должно быть
                nextStoryIndex = this.displayedItems.length + nextStoryIndex
            }

            this.currentIndex = nextStoryIndex;

            nextStoryId = this.displayedItems[nextStoryIndex].id;

            debug(`activateStoryAfterSwipe -  currentStoryIndex: ${currentStoryIndex} currentStoryId: ${this.id} slidesRotated: ${rotatedCnt} nextStoryIndex: ${nextStoryIndex} nextStoryId: ${nextStoryId} this.loadedItemsIndexes: `, this.loadedItemsIndexes);

            if (nextStoryId !== undefined) {

                const currentStory = this.$store.getters['stories/storyId'];
                const currentSlideIndex = this.storyActiveSlide[currentStoryIndex];

                // TODO странный артефакт  !!! commit return void
                // this.$store.commit('SET_ACTIVE_STORY', {storyId: nextStoryId}).then(() => this.$set(this.storyActiveSlide, nextStoryIndex, 0))
                this.$store.commit('stories/SET_ACTIVE_STORY', nextStoryId);
                this.activeStory = nextStoryId;
                this._currentProgress = 0;
                this._progressBeforePause = 0;

                if (this._timer) {
                    this.stopTimer();
                }


                if (slideLoadPromise !== null) {
                    slideLoadPromise.then((result) => {
                        if (result) {
                            this.setTimer();
                            this.slideStart();
                        } else {
                            debug(`slide don\`t loaded: ${nextStoryId}`)
                        }
                    });
                } else {
                    this.setTimer();
                    this.slideStart();
                }


                // возвращаем позицию снова на  центральный сторис
                // if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
                //     this.rotateSliderFlat(-1 * rotatedCnt, true)
                // } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {
                //     this.rotateSliderCover(-1 * rotatedCnt, true)
                // } else {
                //     this.rotateSlider(-1 * rotatedCnt, true)
                // }
                this.updateDisplayedItems();

                this.$emit('nextStories', {
                    toStoryId: this.$store.getters['stories/storyId'],
                    fromStoryId: currentStory,
                    fromSlideIndex: currentSlideIndex
                });
                this.$emit('nextSlide', {fromStoryId: currentStory, fromSlideIndex: currentSlideIndex})
                this.$emit('showSlide', {id: currentStory, index: currentSlideIndex});

                // this.activeSlide = 0
                // this.$set(this.storyActiveSlide, nextStoryIndex, 0)
                // пока что здесь обнуляем таймер при ручном переходе на следующий сторис

                // this.$set(this.storyActiveSlide, nextStoryIndex, 0)
            } else {
                this.closeViewerImportant();
            }
        }
    }

    nextStory(direction: number = 1, isAutoTransition: boolean = false) {
        const currentStoryIndex = this.currentIndex;

        const storyIndex = this.currentIndex;

        const currentStory = this.$store.getters['stories/storyId'];
        const currentSlideIndex = this.storyActiveSlide[storyIndex];

        let nextStoryId: number | null = null, nextStoryIndex = -1;
        if (direction > 0) {
            if (currentStoryIndex !== -1 && this.displayedItems[currentStoryIndex + 1] !== undefined && !this.isBlankStories(this.displayedItems[currentStoryIndex + 1])) {
                nextStoryIndex = currentStoryIndex + 1;
                nextStoryId = this.displayedItems[nextStoryIndex].id;
            }
        } else if (direction < 0) {
            if (currentStoryIndex !== -1 && this.displayedItems[currentStoryIndex - 1] !== undefined && !this.isBlankStories(this.displayedItems[currentStoryIndex - 1])) {
                nextStoryIndex = currentStoryIndex - 1;
                nextStoryId = this.displayedItems[nextStoryIndex].id;
            }
        }


        let waitForSlideLoadedPromise: Nullable<Promise<boolean>> = null;
        if (nextStoryId !== null) {
            this.$emit('closeStoryByScrolling', {id: currentStory});
            waitForSlideLoadedPromise = this.waitForSlideLoaded(nextStoryId);

            this._nextStory(direction).then(() => {
                if (waitForSlideLoadedPromise !== null) {
                    waitForSlideLoadedPromise.then((result) => {
                        if (result) {
                            const index = nextStoryIndex ? this.storyActiveSlide[nextStoryIndex] : currentSlideIndex;
                            this.$emit('nextSlide', {fromStoryId: currentStory, fromSlideIndex: currentSlideIndex});
                            this.$emit('showStory', {id: nextStoryId});
                            this.$emit('showSlide', {id: nextStoryId, index});
                            this.setTimer();
                            this.slideStart();
                        } else {
                            debug(`slide don\`t loaded: ${nextStoryId}`)
                        }
                    });
                }
            });
        } else {
            if (this.readerOptions.recycleStoriesList === true) {

                if (direction < 0) {
                    // recycle to the end
                    let slides = [];
                    if (this.currentStory !== undefined) {
                        slides = this.currentStory.slides_html;
                    }

                    this.$set(this.storyActiveSlide, storyIndex, slides.length - 1);

                    this.waitForSlideLoaded(currentStory).then((result) => {
                        if (result) {
                            this.setTimer();
                            this.slideStart();
                        } else {
                            debug(`slide don\`t loaded: ${currentStory}`)
                        }
                        // this.$emit('nextSlide', {fromStoryId: currentStory, fromSlideIndex: currentSlideIndex})
                    });

                } else {
                    // recycle to begin
                    this.$set(this.storyActiveSlide, storyIndex, 0);
                    this.waitForSlideLoaded(this.$store.getters['stories/storyId']).then((result) => {
                        if (result) {
                            this.setTimer();
                            this.slideStart();
                        } else {
                            debug(`slide don\`t loaded: ${this.$store.getters['stories/storyId']}`)
                        }
                        // this.$emit('nextSlide', {fromStoryId: currentStory, fromSlideIndex: currentSlideIndex})
                    });
                }

            } else {
                // this.$emit('close');
                // this.$emit('closeStory', {id: this.$store.getters['stories/storyId']})

                if (isAutoTransition === true) {
                    if (this.readerOptions.closeOnLastSlideByTimer === false) {
                        // for share page
                        // just stop timer
                    } else {
                        // default bh
                        this.$emit('closeStoryByScrolling', {id: currentStory});
                        this.closeViewerImportant();
                    }
                } else {
                    this.$emit('closeStoryByScrolling', {id: currentStory});
                    this.closeViewerImportant();
                }
            }
        }



    }


    _nextStory(direction: number = 1): Promise<number> {

        const currentStoryIndex = this.currentIndex;

        let nextStoryId: number | null = null, nextStoryIndex = -1;
        if (direction > 0) {
            if (currentStoryIndex !== -1 && this.displayedItems[currentStoryIndex + 1] !== undefined && !this.isBlankStories(this.displayedItems[currentStoryIndex + 1])) {
                nextStoryIndex = currentStoryIndex + 1;
                nextStoryId = this.displayedItems[nextStoryIndex].id;
            }
        } else if (direction < 0) {
            if (currentStoryIndex !== -1 && this.displayedItems[currentStoryIndex - 1] !== undefined && !this.isBlankStories(this.displayedItems[currentStoryIndex - 1])) {
                nextStoryIndex = currentStoryIndex - 1;
                nextStoryId = this.displayedItems[nextStoryIndex].id;
            }
        }

        debug(`nextStory: direction=>${direction} nextStoryId=>${nextStoryId} nextStoryIndex=>${nextStoryIndex}`);

        if (nextStoryId !== null) {

            const currentStory = this.$store.getters['stories/storyId'];
            const currentSlideIndex = this.storyActiveSlide[currentStoryIndex];

            // reset next story active slide
            // this.$set(this.storyActiveSlide, nextStoryIndex, 0);

            return new Promise((resolve, reject) => {
                this.$store.dispatch('stories/FETCH_STORY', nextStoryId).then(() => {


                    // чтобы начать загрузку слайда в этот момент (лоадер крутилка)
                    this.$store.commit('stories/setNextFlippingStory', nextStoryId);

                    this[direction > 0 ? 'navigateSliderNext' : 'navigateSliderPrev'](direction).then(() => {
                        // reset current story
                        // this.$set(this.storyActiveSlide, currentStoryIndex, 0);

                        this.$store.commit('stories/SET_ACTIVE_STORY', nextStoryId);
                        if (nextStoryId !== null) {
                            this.activeStory = nextStoryId
                        }

                        this.currentIndex += direction;

                        debug(`this.currentIndex is: ${this.currentIndex}`);

                        // this.$set(this.storyActiveSlide, nextStoryIndex, 0)

                        // возвращаем позицию снова на  центральный сторис
                        // if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
                        //     this.rotateSliderFlat(-1 * direction, true)
                        // } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {
                        //     this.rotateSliderCover(-1 * direction, true)
                        // } else {
                        //     this.rotateSlider(-1 * direction, true)
                        // }
                        this.updateDisplayedItems();


                        this.$emit('nextStories', {
                            toStoryId: this.$store.getters['stories/storyId'],
                            fromStoryId: currentStory,
                            fromSlideIndex: currentSlideIndex
                        });

                        // todo fetch storyIndex in disaplayed items or in all items if needed

                        if (nextStoryId !== null) {
                            resolve(nextStoryId)
                        } else {
                            reject();
                        }
                    })
                })
            })


        } else {

            return Promise.reject('stories end');
        }

    }



    onSlideReady(storyId: number, slideIndex: number) {

        this.$emit(`slideReady:internal:${storyId}:${slideIndex}`)
        debug(`load - slideReady:internal:${storyId}:${slideIndex}`)

    }
    slideSwipeUpExists(swipeUpLinkTarget?: string) {
        this._swipeUpLinkTarget = swipeUpLinkTarget;
        debug('slideSwipeUpExists: ', swipeUpLinkTarget)
    }
    waitForSlideLoaded(storyId: number): Promise<boolean> {
        debug(`listener load - slideReady ${storyId}`)
        return new Promise((resolve, reject) => {
            this.$once(`slideReady:internal:${storyId}:0`, () => {

                debug('load - slideReady:internal', storyId)

                clearTimeout(timeout);
                this.slideState = 'showed';
                resolve(true);
            })
            const timeout = setTimeout(() => resolve(false), 60 * 1000);
            this.slideState = 'init';
        });
    }

    // global stateBySlide - init/showed
    private slideState: string = 'init';

    // on start loading - init / else - showed

    __afterStartInitQueuePush(cb: ()=>void): boolean {
        if (!isFunction(cb)) {
            return false;
        }

        if (this.slideState === 'init') {
            this.__afterStartInitQueue.push(cb);
        } else {
            cb();
        }

        return true;
    }

    isBlankStories(item: StoriesItem | BlankStoriesItem): boolean {
        return item.blank;
    }

    storiesItemClass({id, index}: { id: number, index: number }): {} {
        // const activeStoryId = this.$store.getters['stories/storyId'];
        let activeStoryIndex = this.currentIndex;
        // let activeStoryIndex = null;

        // for (let prop in this.displayedItems) {
        //   if (this.displayedItems.hasOwnProperty(prop)) {
        //     let item = this.displayedItems[prop]
        //
        //     if (item.id === activeStoryId) {
        //       activeStoryIndex = prop
        //     }
        //   }
        // }
        // this.displayedItems.forEach((item, index) => {
        //     if (item && item.id === activeStoryId) {
        //         activeStoryIndex = index
        //     }
        //     if (item instanceof StoriesItem) {
        //         // debug(`slider_item ${item.id} ${item.title}`)
        //     }
        // })

        const centerSlider = index === activeStoryIndex;
        const leftSlider = index + 1 === activeStoryIndex;
        const rightSlider = index - 1 === activeStoryIndex;


        return {
            // '_active': centerSlider || leftSlider || rightSlider,
            '_active': true,
            '_transform_front': centerSlider,
            '_transform_left': leftSlider,
            '_transform_right': rightSlider,

            // '_position_left': index < activeStoryIndex,
            // '_position_right': index > activeStoryIndex
        }

    }


    pauseAndBlockViewerUI(): void {
        this.timerPaused = true;
        this.pausedUI = true;
    }

    resumeAndEnableViewerUI(): void {
        this.timerPaused = false;
        this.pausedUI = false;
    }


    pauseAndBlockViewerUIForArticleViewer(): void {
        this.articleViewerVisible = true;
        this.timerPaused = true;
        this.pausedUI = true;


    }

    resumeAndEnableViewerUIForArticleViewer(): void {
        this.articleViewerVisible = false;
        this.timerPaused = false;
        this.pausedUI = false;

        /** Чтобы при клике на ту же самую статью - изменился проперти articleUid */
        this.articleUid = '';
    }


    /**
     * Закрыли article viewer
     **/
    closeArticleViewer(): void {
        // articleViewerVisible = false;

        if (this.articleType === ArticleOptions.TYPE) {
            this._statistic !== null && this._statistic.emit(EVENT_ARTICLE_CLOSE, {id: this.articleId});
        } else if (this.articleType === IssueArticleOptions.TYPE) {
            this._statistic !== null && this._statistic.emit(EVENT_ISSUE_ARTICLE_CLOSE, {id: this.articleId});
        }
    }

    pauseAndBlockReaderUIForGameReader(gameData: GameData): void {
        this.gameReaderData = gameData;
        this.gameReaderVisible = true;
        this.timerPaused = true;
        this.pausedUI = true;
    }

    resumeAndEnableReaderUIForGameReader(): void {
        this.gameReaderVisible = false;
        this.timerPaused = false;
        this.pausedUI = false;

        /** Чтобы при клике на ту же самую статью - изменился проперти articleUid */
        this.gameReaderData = null;
    }

    /**
     * Закрыли game reader
     **/
    closeGameReader(): void {

        if (this.articleType === ArticleOptions.TYPE) {
            this._statistic !== null && this._statistic.emit(EVENT_ARTICLE_CLOSE, {id: this.articleId});
        } else if (this.articleType === IssueArticleOptions.TYPE) {
            this._statistic !== null && this._statistic.emit(EVENT_ISSUE_ARTICLE_CLOSE, {id: this.articleId});
        }
    }


    _updateRotaterAnimation() {


    }

    updateRotater({touchmove} = {touchmove: false}): void {

        // if (!touchmove) {
        const rotater: HTMLElement = (<HTMLElement>this.$refs.rotater);
        if (rotater !== null && rotater !== undefined) {
            rotater.style.setProperty('transition', this.rotationTransition);
            rotater.style.setProperty('transform', this.rotationTransform);
        }
        // } else {

        /*          if (!this._rotaterAnimationHandled) {
                    this._rotaterAnimationHandled = true
                    const vm                      = this
                    requestAnimationFrame(function rotaterAnimate(time) {
                      if (vm._rotating) {
                        vm.$refs.rotater.style.setProperty('transition', vm.rotationTransition)
                        vm.$refs.rotater.style.setProperty('transform', vm.rotationTransform)
                        requestAnimationFrame(rotaterAnimate)
                      } else {
                        vm._rotaterAnimationHandled = false
                      }
                    })

                  }
                }*/


    }

    rotateSlider(delta: number, hidden: boolean = false): Promise<number> {

        // start slideLoading here

        // const started = Date.now()
        // let operations = []

        this._rotating = true;
        const newAngle = this._currentAngle + delta * this.angle;
        const rotate = newAngle * -1;
        const transitionTime = sliderOptions.speed / 1000;
        if (this.transformStyle === WidgetStoriesOptions.SWIPE_CUBE) {
            this.rotationTransform = `rotateY(${rotate}deg)`;
        }
        this._currentAngle = newAngle;
        if (hidden) {
            this.rotationTransition = 'transform 0s';
            this.updateRotater();
            this._rotating = false;
            return Promise.resolve(delta);
        }

        // setTimeout(() => {
        //     this._rotating = false
        // }, transitionTime);

        return new Promise((resolve, reject) => {

            let callback = ({propertyName, elapsedTime}: { propertyName: string, elapsedTime: number }) => {

                debug(`transitionend:rotater elapsedTime: ${elapsedTime} transitionTime: ${transitionTime} propertyName: ${propertyName}`);

                if ((Math.round(elapsedTime * 100) / 100) === transitionTime && propertyName === 'transform') {

                    // operations.push(Date.now() - started)
                    this.rotationTransition = 'transform 0s';
                    this.updateRotater();
                    this._rotating = false;

                    debug(`release this._rotating is: ${this._rotating}`);

                    // debug('stop manual rotating')

                    // debug(operations)
                    resolve(delta);
                    this.$off('transitionend:rotater', callback);
                }
            };
            this.$on('transitionend:rotater', callback);
            /*          setTimeout(() => {
                        operations.push(Date.now() - started)
                        this.rotationTransition = 'transform 0s'
                        this.updateRotater()
                        this._rotating = false

                        // debug('stop manual rotating')

                        debug(operations)
                        resolve(delta)
                      }, sliderOptions.speed)*/

            this.rotationTransition = `transform ${transitionTime}s ${sliderOptions.easing}`;
            this.updateRotater();

        })
    }

    rotateSliderFlat(delta: number, hidden: boolean = false): Promise<number> {

        // const started = Date.now()
        // let operations = []

        this._rotating = true;

        let centralStoriesTransform: string = '',
            rightStoriesTransform: string = '',
            leftStoriesTransform: string = '';

        if (delta === 0) {
            leftStoriesTransform = `translateZ(0) translateX(-100%)`;
            centralStoriesTransform = `translateZ(0) translateX(0%)`;
            rightStoriesTransform = `translateZ(0) translateX(100%)`;
        } else if (delta > 0) {
            leftStoriesTransform = `translateZ(0) translateX(-200%)`;
            centralStoriesTransform = `translateZ(0) translateX(-100%)`; // 0 => -100%
            rightStoriesTransform = `translateZ(0) translateX(0%)`; // 100% => 0
        } else {
            centralStoriesTransform = `translateZ(0) translateX(100%)`; // 0 => 100%
            leftStoriesTransform = `translateZ(0) translateX(0%)`; // -100% => 0
            rightStoriesTransform = 'translateZ(0) translateX(200%)';
        }


        if (hidden) {
            this.rotationTransition = 'transform 0s';
            this.updateRotater();


            this.centralSlideEl !== null && this.centralSlideEl.style.setProperty('transform', centralStoriesTransform);
            this.rightSlideEl !== null && this.rightSlideEl.style.setProperty('transform', rightStoriesTransform);
            this.leftSlideEl !== null && this.leftSlideEl.style.setProperty('transform', leftStoriesTransform);

            this._rotating = false;
            return Promise.resolve(delta);
        }

        const transitionTime = sliderOptions.speed / 1000;
        return new Promise((resolve, reject) => {
            let callback = ({propertyName, elapsedTime}: { propertyName: string, elapsedTime: number }) => {
                if ((Math.round(elapsedTime * 100) / 100) === transitionTime && propertyName === 'transform') {

                    // operations.push(Date.now() - started)
                    this.rotationTransition = 'transform 0s';
                    this.updateRotater();
                    this._rotating = false;

                    // debug('stop manual rotating')

                    // debug(operations)
                    this.$off('transitionend:rotater', callback);
                    resolve(delta);
                }
            };
            this.$on('transitionend:rotater', callback);
            /*          setTimeout(() => {
                        operations.push(Date.now() - started)
                        this.rotationTransition = 'transform 0s'
                        this.updateRotater()
                        this._rotating = false

                        // debug('stop manual rotating')

                        debug(operations)
                        resolve(delta)
                      }, sliderOptions.speed)*/

            this.rotationTransition = `transform ${transitionTime}s ${sliderOptions.easing}`;
            this.updateRotater();

            this.centralSlideEl !== null && this.centralSlideEl.style.setProperty('transform', centralStoriesTransform);
            this.rightSlideEl !== null && this.rightSlideEl.style.setProperty('transform', rightStoriesTransform);
            this.leftSlideEl !== null && this.leftSlideEl.style.setProperty('transform', leftStoriesTransform);

        })
    }

    rotateSliderCover(delta: number, hidden: boolean = false): Promise<number> {

        // const started = Date.now()
        // let operations = []

        this._rotating = true;

        let centralStoriesTransform: string = '',
            rightStoriesTransform: string = '',
            leftStoriesTransform: string = '';

        if (delta === 0) {
            leftStoriesTransform = `translateZ(0) translateX(-10%) scale(.9)`;
            centralStoriesTransform = `translateZ(0) translateX(0%) scale(1)`;
            rightStoriesTransform = `translateZ(0) translateX(100%) scale(1)`;
        } else if (delta > 0) {
            leftStoriesTransform = `translateZ(0) translateX(-20%) scale(.8)`;
            centralStoriesTransform = `translateZ(0) translateX(-10%) scale(.9)`; // 0 => -100%
            rightStoriesTransform = `translateZ(0) translateX(0%) scale(1)`; // 100% => 0
        } else {
            centralStoriesTransform = `translateZ(0) translateX(100%) scale(1)`; // 0 => 100%
            leftStoriesTransform = `translateZ(0) translateX(0%) scale(1)`; // -100% => 0
            rightStoriesTransform = `translateZ(0) translateX(200%)`;
        }

        if (hidden) {
            this.rotationTransition = 'transform 0s';
            this.updateRotater();


            this.centralSlideEl !== null && this.centralSlideEl.style.setProperty('transform', centralStoriesTransform);
            this.rightSlideEl !== null && this.rightSlideEl.style.setProperty('transform', rightStoriesTransform);
            this.leftSlideEl !== null && this.leftSlideEl.style.setProperty('transform', leftStoriesTransform);

            this._rotating = false;
            return Promise.resolve(delta);
        }

        const transitionTime = sliderOptions.speed / 1000;
        return new Promise((resolve, reject) => {
            let callback = ({propertyName, elapsedTime}: { propertyName: string, elapsedTime: number }) => {
                if ((Math.round(elapsedTime * 100) / 100) === transitionTime && propertyName === 'transform') {

                    // operations.push(Date.now() - started)
                    this.rotationTransition = 'transform 0s';
                    this.updateRotater();
                    this._rotating = false;

                    // debug('stop manual rotating')

                    // debug(operations)
                    this.$off('transitionend:rotater', callback);
                    resolve(delta);
                }
            };
            this.$on('transitionend:rotater', callback);
            /*          setTimeout(() => {
                        operations.push(Date.now() - started)
                        this.rotationTransition = 'transform 0s'
                        this.updateRotater()
                        this._rotating = false

                        // debug('stop manual rotating')

                        debug(operations)
                        resolve(delta)
                      }, sliderOptions.speed)*/

            this.rotationTransition = `transform ${transitionTime}s ${sliderOptions.easing}`;
            this.updateRotater();

            this.centralSlideEl !== null && this.centralSlideEl.style.setProperty('transform', centralStoriesTransform);
            this.rightSlideEl !== null && this.rightSlideEl.style.setProperty('transform', rightStoriesTransform);
            this.leftSlideEl !== null && this.leftSlideEl.style.setProperty('transform', leftStoriesTransform);

        })

    }

    navigateSliderNext(delta: number): Promise<number> {
        if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
            return this.rotateSliderFlat(delta)
        } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {
            return this.rotateSliderCover(delta)
        } else {
            return this.rotateSlider(delta)
        }
    }

    navigateSliderPrev(delta: number): Promise<number> {
        if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
            return this.rotateSliderFlat(delta)
        } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {
            return this.rotateSliderCover(delta)
        } else {
            return this.rotateSlider(delta)
        }
    }

    dragRotationHandler(e: Event) {
        let widgetSliderElement: HTMLElement | null = null,
            target: any = e.target;
        if (target.classList.contains('narrative-element-range-slider')) {
            widgetSliderElement = target;
        } else {
            widgetSliderElement = target.closest('.narrative-element-range-slider');
        }

        if (widgetSliderElement !== null) {
            // e.preventDefault();
            return;
        }


        if (this.desktopMode) return;

        // проверить что _rotating по завершении устанавливается в false
        // и что выполняются предыдущие promise

        debug(`this._rotating is: ${this._rotating}`);
        if (this._rotating && !sliderOptions.allowDragDuringAnim) return;
        if (this.pausedUI) {
            return
        }
        e.stopPropagation();

        // разрешаем предыдущий promise
        if (this._animationEndPromise) {
            debug(this._animationEndPromise);
            // this._animationEndPromise.resolve(this._animationEndPromiseDelta)

            this.activateStoryAfterSwipe((<number>this._animationEndPromiseDelta), null);
            this._animationEndPromise = null;
        }


        let startAt = Date.now();

        if (this._pausedTimerId) {
            clearTimeout(this._pausedTimerId);
            this._pausedTimerId = null
        }
        this._pausedTimerId = setTimeout(() => {
            this.timerPaused = true
        }, 200);


        if (this._pausedUITimerId) {
            clearTimeout(this._pausedUITimerId);
            this._pausedUITimerId = null
        }
        this._pausedUITimerId = setTimeout(() => {
            if (this.timerPaused === true) {
                this.pausedUI = true
            }
        }, 1500);

        // TODO also stop video and gif

        this._rotating = true;
        if (this._slider !== null) {
            this._slider.classList.add('no-select')
        }

        // let pageWidth = _winWidth();
        // let treshold  = Math.max(1, Math.floor(0.01 * (pageWidth)))
        let treshold = 0;
        const limit = Math.tan(45 * 1.5 / 180 * Math.PI);

        let startVal: number,
            startValY: number;
        startVal = (<any>e).pageX || ((<TouchEvent>e).touches && (<TouchEvent>e).touches[0].pageX);
        startValY = (<any>e).pageY || ((<TouchEvent>e).touches && (<TouchEvent>e).touches[0].pageY);

        let sliderS: number = this._innerSlider !== null ? this._innerSlider.clientWidth : 0;
        let windowHeight: number = this._slider !== null ? this._slider.clientHeight : 0;
        let deltaVal: number = 0;
        let newAngle: number;
        let angleDelta: number;
        let rotationCoef: number;
        rotationCoef = sliderOptions.dragSpeedCoef;

        let deltaValY = 0;

        let globalHorizontalSwipeGesture = false;
        let globalVerticalSwipeGesture = false;

        const storiesViewer: HTMLElement = (<HTMLElement>this.$refs.storiesViewer);
        storiesViewer.style.setProperty('transition', '');

        let touchmoveListener = (e: Event): void => {
            e.preventDefault();
            e.stopPropagation();

            if (this.pausedUI) {
                return
            }

            let val,
                valY;

            // TODO y rotation + detect close swipe
            val = (<any>e).pageX || ((<TouchEvent>e).touches && (<TouchEvent>e).touches[0].pageX);
            valY = (<any>e).pageY || ((<TouchEvent>e).touches && (<TouchEvent>e).touches[0].pageY);

            // если еще не успели войти в pausedUI и начали двигать - то отменяем переход в pausedUI
            if (Math.abs(startVal - val) > 0 && this.pausedUI === false && this._pausedUITimerId) {
                clearTimeout(this._pausedUITimerId);
                this._pausedUITimerId = null;
                return;
            }

            let x = val - startVal;
            let y = valY - startValY;
            let xy = Math.abs(x / y);
            let yx = Math.abs(y / x);

            let horizontalSwipeGesture = false;
            let verticalSwipeGesture = false;
            let tapGesture = false;

            // debug(xy, limit, xy <= limit)

            if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
                // if (yx <= limit) {
                if (x < 0) {
                    horizontalSwipeGesture = true;
                    // debug("left");
                } else {
                    horizontalSwipeGesture = true;
                    // debug("right");
                }
                // }
                if (xy <= limit) {
                    if (y < 0) {
                        verticalSwipeGesture = true;
                        // debug("top");
                    } else {
                        verticalSwipeGesture = true;
                        // debug("bottom");
                    }
                }
            } else {
                tapGesture = true;
                // debug("tap");
            }

            /** swipe down on 20% */
            if (verticalSwipeGesture && !globalHorizontalSwipeGesture) {
                globalVerticalSwipeGesture = true;

                // если есть swipe_up - пауза у таймера
                // никакой трансформации у сторис
                // открыть поверх iframe с контентом (протянуть снизу вверх)
                // независимо от пальца



                if (y > 10 || this.closeGestureInAction) {
                    this.closeGestureInAction = true;
                    deltaValY = y / windowHeight;

                    // max scale = .9
                    // max translateY = 45%

                    let scaleFactor = 1 - ((1 - .9) * deltaValY);
                    if (scaleFactor >= 1) {
                        scaleFactor = 1;
                    }

                    let translateY = deltaValY * 100 * (45 / 100); // in percent
                    if (translateY <= 0) {
                        translateY = 0;
                    }

                    // todo ограничить fps 60

                    // _debounce(() => {
                    const storiesViewer: HTMLElement = (<HTMLElement>this.$refs.storiesViewer);
                    storiesViewer.style.setProperty('transform', `scale(${scaleFactor}) translateY(${translateY}%)`);
                    // }, 150, {
                    //   'leading': true,
                    //   'trailing': false
                    // })




                } else if (y < -10 || this.swipeUpGestureInAction) {
                    this.swipeUpGestureInAction = true;
                    deltaValY = y / windowHeight;
                }

            } else if (horizontalSwipeGesture && !globalVerticalSwipeGesture) {

                this.closeGestureInAction = false;

                globalHorizontalSwipeGesture = true;

                deltaVal = (startVal - val) / sliderS * rotationCoef;

                newAngle = this._currentAngle + deltaVal * this.angle;
                angleDelta = newAngle - this._currentAngle;

                if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT || this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {

                    // set swipe limit for blank stories
                    if (this.nextStoryBlank || this.prevStoryBlank) {
                        if (deltaVal >= .05 && this.nextStoryBlank) {
                            deltaVal = .05;
                        } else if (deltaVal <= -.05 && this.prevStoryBlank) {
                            deltaVal = -.05;
                        }
                    }

                } else {

                    // set swipe limit for blank storis
                    if (this.nextStoryBlank || this.prevStoryBlank) {
                        if (angleDelta >= 5 && this.nextStoryBlank) {
                            newAngle = this._currentAngle + 5
                        } else if (angleDelta <= -5 && this.prevStoryBlank) {
                            newAngle = this._currentAngle - 5
                        }
                    }
                }

                let rotate = newAngle * -1;
                // debug(`rotateY(${rotate}deg)`)

                if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
                    let centralStoriesTransform: string = '',
                        rightStoriesTransform: string = '',
                        leftStoriesTransform: string = '';

                    leftStoriesTransform = `translateZ(0) translateX(${(1 + deltaVal) * -100}%)`; // -100% => 0 when delta 0 => -1 && -100 => -200 when delta 0 => 1
                    centralStoriesTransform = `translateZ(0) translateX(${deltaVal * -100}%)`; // 0 => -100%
                    rightStoriesTransform = `translateZ(0) translateX(${(1 - deltaVal) * 100}%)`; // 100% => 0

                    this.centralSlideEl !== null && this.centralSlideEl.style.setProperty('transform', centralStoriesTransform);
                    this.rightSlideEl !== null && this.rightSlideEl.style.setProperty('transform', rightStoriesTransform);
                    this.leftSlideEl !== null && this.leftSlideEl.style.setProperty('transform', leftStoriesTransform);

                } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {

                    let centralStoriesTransform: string = '',
                        rightStoriesTransform: string = '',
                        leftStoriesTransform: string = '';

                    // scale
                    // .9 => 1 when delta 0 => -1 (swipe to right)
                    // 1 => .9 when delta 0 => 1 (swipe to left)


                    // transformX
                    // -10% when delta 0 => -.9
                    // -10% - 0 when  delta -.9 => -1
                    // 0% => -10% when delta 0 => .1
                    // -10% when delta .1 => 1


                    // (1 + deltaVal) * -100
                    // Math.min((1 + deltaVal) * 100, 10) * -1
                    leftStoriesTransform = `translateZ(0) translateX(${(0.1 - (-1 * deltaVal / 10)) * -100}%) scale(${Math.min(0.9 + (-1 * deltaVal / 10), 1.0)})`; // -100% => 0 when delta 0 => -1 && -100 => -200 when delta 0 => 1
                    centralStoriesTransform = `translateZ(0) translateX(${deltaVal <= 0 ? (deltaVal * -100) : ((0 - (-1 * deltaVal / 10)) * -100)}%) scale(${(deltaVal <= 0 ? 1 : (1 + (-1 * deltaVal / 10)))})`;
                    rightStoriesTransform = `translateZ(0) translateX(${(1 - deltaVal) * 100}%) scale(1)`; // 100% => 0

                    this.centralSlideEl !== null && this.centralSlideEl.style.setProperty('transform', centralStoriesTransform);
                    this.rightSlideEl !== null && this.rightSlideEl.style.setProperty('transform', rightStoriesTransform);
                    this.leftSlideEl !== null && this.leftSlideEl.style.setProperty('transform', leftStoriesTransform);

                } else {
                    // SWIPE_CUBE
                    this.rotationTransform = `rotateY(${rotate}deg)`;
                }


                this.updateRotater({touchmove: true}); // animation frame
            }

        };

        if (this._slider !== null) {
            this._slider.addEventListener('mousemove', touchmoveListener, false);
            this._slider.addEventListener('touchmove', touchmoveListener, false);
        }

        let touchendListener = (e: Event | TouchEvent) => {
            debug('touchendListener', e);
            if (this._slider !== null) {
                this._slider.removeEventListener('mousemove', touchmoveListener);
                this._slider.removeEventListener('touchmove', touchmoveListener);
                this._slider.removeEventListener('mouseup', touchendListener);
                this._slider.removeEventListener('touchend', touchendListener);
            }

            // если не успели перейти в режим paused
            if (this.timerPaused === false && this._pausedTimerId) {
                clearTimeout(this._pausedTimerId);
                this._pausedTimerId = null
            }

            if (this._slider !== null) {
                this._slider.classList.remove("no-select");
            }

            if (!deltaVal) {

                if (this.timerPaused) {
                    e.preventDefault();
                    e.stopPropagation();
                }

                this._rotating = false;
                this.timerPaused = false;
                this.pausedUI = false;


                if (globalVerticalSwipeGesture && deltaValY) {

                    const storiesViewer: HTMLElement = (<HTMLElement>this.$refs.storiesViewer);

                    let currentItem: StoriesItem|BlankStoriesItem|undefined = this.displayedItems[this.currentIndex];
                    let disable_close = false;
                    if (!this.isBlankStories(currentItem) && currentItem instanceof StoriesItem) {
                        disable_close = currentItem.disable_close;
                    }

                    // swipe_down
                    if (deltaValY >= 0) {
                        if (deltaValY <= .15 || disable_close) {
                            storiesViewer.style.setProperty('transition', 'all .3s');
                            storiesViewer.style.setProperty('transform', 'scale(1) translateY(0%)');
                        } else {
                            // TODO animation here
                            storiesViewer.style.setProperty('transition', 'opacity .3s');
                            storiesViewer.style.setProperty('opacity', '0');
                            if (this._backdrop !== null) {
                                this._backdrop.style.setProperty('transition', 'opacity .3s');
                                this._backdrop.style.setProperty('opacity', '0');
                            }
                            setTimeout(() => {
                                this.closeViewer();
                            }, 400);
                        }
                    } else {

                        // if swipe_up available on this slide
                        if (this._swipeUpLinkTarget) {
                            this.$emit('clickOnButton', {id: this.$store.getters['stories/storyId'], index: this.storyActiveSlide[this.currentIndex], url: this._swipeUpLinkTarget})
                        }

                    }

                    globalVerticalSwipeGesture = false;
                    this.closeGestureInAction = false;

                }

                return;
            }

            const endAt = Date.now();
            let slidesRotated = Math.round(angleDelta / this.angle);

            if (slidesRotated === 0) {
                // fast swipe
                if (endAt - startAt <= 500) {
                    slidesRotated = deltaVal < 0 ? -1 : 1;
                }
            }

            if (slidesRotated < 0 && this.prevStoryBlank) {
                slidesRotated = 0;
            } else if (slidesRotated > 0 && this.nextStoryBlank) {
                slidesRotated = 0;
            }

            debug('before rotate', Date.now());
            const started = Date.now();

            let animationEndPromise: Promise<number> | null = null;

            if (this.transformStyle === WidgetStoriesOptions.SWIPE_FLAT) {
                animationEndPromise = this.rotateSliderFlat(slidesRotated);
            } else if (this.transformStyle === WidgetStoriesOptions.SWIPE_COVER) {
                animationEndPromise = this.rotateSliderCover(slidesRotated);
            } else {
                // SWIPE_CUBE
                animationEndPromise = this.rotateSlider(slidesRotated);
            }

            if (animationEndPromise !== null) {



                const currentStoryIndex = this.currentIndex;

                let nextStoryId: number | null = null, nextStoryIndex = -1;
                if (slidesRotated > 0) {
                    if (currentStoryIndex !== -1 && this.displayedItems[currentStoryIndex + 1] !== undefined && !this.isBlankStories(this.displayedItems[currentStoryIndex + 1])) {
                        nextStoryIndex = currentStoryIndex + 1;
                        nextStoryId = this.displayedItems[nextStoryIndex].id;
                    }
                } else if (slidesRotated < 0) {
                    if (currentStoryIndex !== -1 && this.displayedItems[currentStoryIndex - 1] !== undefined && !this.isBlankStories(this.displayedItems[currentStoryIndex - 1])) {
                        nextStoryIndex = currentStoryIndex - 1;
                        nextStoryId = this.displayedItems[nextStoryIndex].id;
                    }
                }

                let slideLoadPromise: Nullable<Promise<boolean>> = null;
                if (nextStoryId !== null) {
                    slideLoadPromise = this.waitForSlideLoaded(nextStoryId);
                    // чтобы начать загрузку слайда в этот момент (лоадер крутилка)
                    this.$store.commit('stories/setNextFlippingStory', nextStoryId);
                }


                this._animationEndPromise = animationEndPromise;
                this._animationEndPromiseDelta = slidesRotated;
                animationEndPromise.then((direction: number) => {

                    this._animationEndPromise = null;

                    debug('activateStoryAfterSwipe call', Date.now(), Date.now() - started);

                    // debug(`slide direction ${direction}, angleDelta ${angleDelta}, angle ${this.angle}, slidesRotated ${slidesRotated} deltaVal ${deltaVal} ` )
                    // не давать прокручивать больше одного
                    // если индекс слайда не поменялся - значит не dspsdnm и rotateSlider
                    // start next story fnc

                    this.timerPaused = false;
                    this.pausedUI = false;
                    // reset current story
                    // this.$set(this.storyActiveSlide, this.fetchStoryIndex(this.id), 0)

                    this.activateStoryAfterSwipe(slidesRotated, slideLoadPromise);

                });
            }

            deltaVal = 0;

        };

        if (this._slider !== null) {
            this._slider.addEventListener('mouseup', touchendListener, false);
        }
        if (this._slider !== null) {
            this._slider.addEventListener('touchend', touchendListener, false)
        }
    }

    // load() {
    //   return fetchStories().then(({val, totalCount, currentPage}) => {
    //     this.displayedItems = val
    //   })
    // }

    init3DSlider() {
        // TODO if visible and other resize handler

        if (this._slider && this._innerSlider) {

            // если viewer скрыт - то this._slider.clientWidth === 0
            let sliderWidth = this._innerSlider.clientWidth;
            if (sliderWidth > 0) {
                this.$store.commit('stories/setSliderWidth', sliderWidth);
            }
            if (!this._innerSlider.clientWidth && this._sliderWidth) {
                sliderWidth = this._sliderWidth;
            }

            this.angle = 360 / 8;
            if (this.transformStyle === WidgetStoriesOptions.SWIPE_CUBE) {
                this.perspective = sliderWidth * sliderOptions.persMult;
                this.depth = sliderWidth / 2 / Math.tan(this.angle / 2 * Math.PI / 180);
            }
        }
    }

    // в setup START
    private _viewportWidth: number = _winWidth();
    private _viewportHeight: number = _winHeight();
    private _viewportRatio: number = this._viewportWidth / this._viewportHeight;

    public storiesSlideBottomPosition(story?: StoriesItem | BlankStoriesItem): number {
        if (typeof story !== 'undefined' && story instanceof StoriesItem) {
            if (this.needBottomPanel) {
                return 50;
            }
        }
        return 0;
    }

    // TODO вынести все манипуляции с viewPort size/resize/orientation/desktopMode на уровень выше
    // здесь оставить только offsetBox расчитываемый по viewport
    private _slideViewportHeight(story?: StoriesItem | BlankStoriesItem): number {
        // debug('_viewportHeight', this._viewportHeight)
        let slideViewportHeight = this._viewportHeight;
        // отступы сверху и снизу
        if (this.desktopMode) {
            slideViewportHeight -= 100;
        }
        // 50 if hasLike or favorite
        slideViewportHeight -= this.storiesSlideBottomPosition(story);

        return slideViewportHeight;
    }

    private _slideRatio = 0.64516129032; // 310/480
    private _slideWidth(story?: StoriesItem | BlankStoriesItem): number {
        if (this.desktopMode) {
            return Math.ceil(this._slideViewportHeight(story) * this._slideRatio);
        } else {
            if (this._viewportRatio > this._slideRatio) {
                return this._viewportWidth;
            } else {
                return Math.ceil(this._slideViewportHeight(story) * this._slideRatio);
            }
        }
    }


    public storiesSlideWidth(story?: StoriesItem | BlankStoriesItem): string {
        // default auto
        let mql = undefined;

        /** для viewportRatio близких к _ratio **/
        if ((this._viewportRatio > this._slideRatio && (this._viewportRatio - this._slideRatio) <= .1)
            // ||
            // (('matchMedia' in window) && ((mql = window.matchMedia("(orientation: portrait)")) !== undefined) && mql.matches)
        ) {
            return 'auto';
        }

        if (this._viewportRatio > this._slideRatio) {
            return `${this._slideWidth(story)}px`;
        } else {
            return 'auto';
        }
    }

    private _slideHeight(story?: StoriesItem | BlankStoriesItem): number {
        if (this.desktopMode) {
            return Math.ceil(this._slideWidth(story) / this._slideRatio);
        } else {
            return Math.ceil(this._viewportWidth / this._slideRatio);
        }
    }

    public storiesSlideHeight(story?: StoriesItem | BlankStoriesItem): string {
        // default auto
        let mql = undefined;

        /** для viewportRatio близких к _ratio **/
        if ((this._viewportRatio > this._slideRatio && (this._viewportRatio - this._slideRatio) <= .1) ||
            (('matchMedia' in window) && ((mql = window.matchMedia("(orientation: portrait)")) !== undefined) && mql.matches)
        ) {
            return '100%';
        }

        if (this._viewportRatio > this._slideRatio) {
            return `${this._slideHeight(story)}px`;
        } else {
            return '100%';
        }
    }

    public storiesSlideOffsetY(story?: StoriesItem | BlankStoriesItem): string {
        if (this._viewportRatio > this._slideRatio) {
            return `${Math.ceil(this._slideHeight(story) - this._slideViewportHeight(story)) / 2}px`;
        } else {
            return '0px';
        }
    }

    public storiesSlideOffsetX(story?: StoriesItem | BlankStoriesItem): string {
        if (this._viewportRatio > this._slideRatio) {
            return '0px';
        } else {
            return `${Math.ceil(this._slideWidth(story) - this._viewportWidth) / 2}px`;
        }
    }

    public storiesSlideOffset(story?: StoriesItem | BlankStoriesItem): string {
        if (this._viewportRatio > this._slideRatio) {
            return `${-1 * (Math.ceil(this._slideHeight(story) - this._slideViewportHeight(story)) / 2)}px auto`;
        } else {
            return `0 ${-1 * (Math.ceil(this._slideWidth(story) - this._viewportWidth) / 2)}px`;
        }
    }

    public slideFontSize(story?: StoriesItem | BlankStoriesItem): string {
        return (this._slideWidth(story) / 20) + 'px';
    }

    // в setup END

    onTransitionEnd(e: Event | TransitionEvent) {
        this.$emit('transitionend:rotater', {
            propertyName: (<TransitionEvent>e).propertyName,
            elapsedTime: (<TransitionEvent>e).elapsedTime
        })
    }

    initSlidesAspectRatio() {
        this._viewportWidth = _winWidth();
        this._viewportHeight = _winHeight();
        this._viewportRatio = this._viewportWidth / this._viewportHeight;
        // без него не хочет по viewportRatio обновлять slideWidth в разметеке
        this.$forceUpdate();
    }


    wrongScreenOrientation: Nullable<boolean> = null;
    checkScreenOrientation() {
        if (this.desktopMode)
            return;

        this.wrongScreenOrientation = orientation.type !== SCREEN_ORIENTATIONS.PORTRAIT_PRIMARY;

        const ratioUpdate = () => {
            this.initSlidesAspectRatio();
            this.$forceUpdate();
            this.$nextTick(() => this.init3DSlider());
        };
        setTimeout(ratioUpdate, 0);
        setTimeout(ratioUpdate, 10);
        setTimeout(ratioUpdate, 300);

    }

    initBaseHandlers() {
        this.$on('transitionFromSlide', ({storyId, transitionToType, transitionToId}: { storyId: number, transitionToType: string, transitionToId: number }) => {
            this.$store.dispatch('shared/UPDATE_STORY_OPENED', {id: storyId, value: true});
            // this.$store.getters['stories/items'][storyId].isOpened = true
            this.$emit('storyOpenedInternal', {id: storyId});
        });

        this.$on('close', () => {
            this.$store.dispatch('shared/UPDATE_STORY_OPENED', {id: this.id, value: true});
            // this.$store.getters['stories/items'][this.id].isOpened = true;
            this.$emit('storyOpenedInternal', {id: this.id});

            this.$store.dispatch('stories/UPDATE_STORIES_ACTIVE_INDEX', this.fetchStoryIndexInLoaded(this.id));
            // this.$store.dispatch('UPDATE_STORIES_ORDER')
            const fromStoryId = this.id;
            const fromSlideIndex = this.storyActiveSlide[this.currentIndex];
        });

        this.$on('openViewer', function ({storiesId}: { storiesId: number }) {
            (<any>window).__activeNarrativeId = storiesId;
        });


        this.$on('nextStories', ({toStoryId, fromStoryId, fromSlideIndex}: { toStoryId: number, fromStoryId: number, fromSlideIndex: number }) => {
            (<any>window).__activeNarrativeId = toStoryId;
        });

        this.$on('nextSlide', ({fromStoryId, fromSlideIndex}: { fromStoryId: number, fromSlideIndex: number }) => {
            debug(`fromSlideIndex: ${fromSlideIndex}`);
            if (this.$store.getters['shared/items'].get(fromStoryId) !== undefined) {
                this.$store.dispatch('shared/UPDATE_STORY_OPENED', {id: fromStoryId, value: true});
                // this.$store.getters['stories/items'][fromStoryId].isOpened = true
                this.$emit('storyOpenedInternal', {id: fromStoryId});
            }
        });


    }


    /**
     * initStatistic
     */
    initStatistic() {

        this.$on('transitionFromSlide', ({storyId, transitionToType, transitionToId}: { storyId: number, transitionToType: string, transitionToId: number }) => {

            const event: TransitionFromSlideEvent = {
                storyId: storyId,
                slideIndex: this.storyActiveSlide[this.currentIndex],
                transitionToType: transitionToType,
                transitionToId: transitionToId
            };
            this._statistic !== null && this._statistic.emit(EVENT_STORIES_TRANSITION_FROM_SLIDE, event);

            this.$store.dispatch('shared/UPDATE_STORY_OPENED', {id: storyId, value: true});
            // this.$store.getters['stories/items'][storyId].isOpened = true

        });

        const actionOnClose = () => {

            this._statistic !== null && this._statistic.emit('closeStoriesViewer', {
                storyId: this.id,
                slideIndex: this.storyActiveSlide[this.currentIndex]
            });

        };

        /** скрытие на время перехода в статью **/
        // this.$on('hideViewer', actionOnClose);

        this.$on('close', actionOnClose);

        this.$on('openViewer', function ({storiesId}: { storiesId: number }) {

            ('ga' in window) && (<any>window).ga('main.send', {
                hitType: 'pageview',
                page: "NarrativeViewer"
            });
            ('ga' in window) && (<any>window).ga('main.send', 'event', 'NarrativeViewer', 'show', 'Open viewer', storiesId)
        });

        this.$on('nextStories', ({toStoryId, fromStoryId, fromSlideIndex}: { toStoryId: number, fromStoryId: number, fromSlideIndex: number }) => {
            this._statistic !== null && this._statistic.emit('nextStory', {toStoryId, fromStoryId, fromSlideIndex});
        });

        this.$on('nextSlide', ({fromStoryId, fromSlideIndex}: { fromStoryId: number, fromSlideIndex: number }) => {
            this._statistic !== null && this._statistic.emit(EVENT_STORIES_NEXT_SLIDE, {
                fromStoryId,
                fromSlideIndex
            });
        });

        this.$on('showViewerAfterHide', () => {
            this._statistic !== null && this._statistic.emit('showStoriesViewerAfterHide');
        });


        let _doAjaxBeforeUnloadEnabled: boolean = true;
        const _doAjaxBeforeUnload = (e: Event): void => {
            if (!_doAjaxBeforeUnloadEnabled) {
                return;
            }
            _doAjaxBeforeUnloadEnabled = false;


            /** Запущен article viewer - закрываем и вызываем событие закрытия для статистики */
            if (this.articleViewerVisible) {
                this.closeArticleViewer();
            }

            /** Закрываем основной viewer */
            this.closeViewer();

            return;

        };

        window.onbeforeunload = _doAjaxBeforeUnload;
        window.addEventListener('unload', (e: Event) => {
            _doAjaxBeforeUnload(e)
        });


    }

    refreshSlidesLinks(): void {
        if (this.$refs.storiesSlide !== undefined) {
            this.leftSlideEl = (<HTMLElement>this.$refs.rotater).querySelector('._transform_left');
            this.centralSlideEl = (<HTMLElement>this.$refs.rotater).querySelector('._transform_front');
            this.rightSlideEl = (<HTMLElement>this.$refs.rotater).querySelector('._transform_right');
        }
    }

    setLike(item: StoriesItem, like: number): void {
        this.$store.dispatch('shared/UPDATE_STORY_LIKE', {id: item.id, like})
        this.$emit('likeStory', {id: item.id, value: like === 1})
    }
    setDislike(item: StoriesItem, like: number): void {
        this.$store.dispatch('shared/UPDATE_STORY_LIKE', {id: item.id, like})
        this.$emit('dislikeStory', {id: item.id, value: like === -1})
    }

    private _blockFavoriteBtn = false;
    setBookmark(item: StoriesItem, favorite: number): void {
        if (!this._blockFavoriteBtn) {
            this._blockFavoriteBtn = true;
            this.$store.dispatch('shared/UPDATE_STORY_FAVORITE', {id: item.id, favorite})
                .then(value => {
                    // this.$emit('favoriteStoryInternal', {id: item.id, value});
                })
                .catch(e => {
                    console.error('UPDATE_STORY_FAVORITE', e);
                })
                .finally(() => {
                    this._blockFavoriteBtn = false;
                });

            // just click
            // todo add favorite success and fail events
            this.$emit('favoriteStory', {id: item.id, value: favorite === 1});
        }
    }


    shareLink: Nullable<string> = null;
    sharePanelOpen = false;
    shareId: string = '';

    async actionShare(item: StoriesItem) {
        this.$emit('shareStory', {id: item.id})

        const performShareAction = () => {
            let sharePath = this.$store.getters['shared/items'].get(item.id)?.sharePath;
            if (sharePath) {
                this.$emit('shareStoryWithPath', {id: item.id, url: sharePath})

                const openSharePanel = () => {
                    this.shareLink = sharePath;
                    this.sharePanelOpen = true;
                }
                const pauseUI = () => {
                    this.timerPaused = true;
                    this.pausedUI = true;
                }
                const resumeUI = () => {
                    this.timerPaused = false;
                    this.pausedUI = false;
                }

                if (this.desktopMode || !(<any>navigator).share) {
                    openSharePanel();
                    pauseUI();
                } else {
                    try {
                        (<any>navigator).share({
                            title: this.$store.getters['shared/items'].get(item.id)?.title,
                            text: '',
                            url: sharePath,
                        })
                            .then(() => resumeUI())
                            .catch((error: any) => resumeUI());
                        pauseUI();
                    } catch (e) {
                        // navigator.share есть но не срабатывает на win 7 например
                        openSharePanel();
                        pauseUI();
                    }
                }
            }
        };

        // TODO если !needSession - это share_page и sharePath уже есть в сторе
        if (needSession()) {
            try {
                await this.$store.dispatch('shared/GET_SHARE_PATH', {id: item.id});
                performShareAction();
            } catch (e) {
                console.error(e);
            }
        } else {
            performShareAction();
        }

    }

    sharePanelComplete(isSuccess: boolean) {
        this.timerPaused = false;
        this.pausedUI = false;
        if (this.shareId) {
            (<any>window).share_complete(this.shareId, isSuccess);
            this.shareId = '';
        }
    }

    async onMute(): Promise<void> {
        await this.$store.dispatch('stories/MUTE');
    }
    async onUnmute(): Promise<void> {
        await this.$store.dispatch('stories/UNMUTE');
    }


    beforeCreate() {

    }

    created() {

        this.createDisplayedItems();

        // push history state

        this._body = document.querySelector('body');

        this._backdrop = document.createElement('div');
        this._backdrop.classList.add('stories-viewer-backdrop');


        this._currentProgress = 0;
        this._progressBeforePause = 0;

        this._pausedSlide = null;
        this._pausedStory = null;

        this._currentAngle = 0;
        this._rotating = false;

        this._slider = null;
        this._innerSlider = null;

        this.sliderWidth = 0;

        this._pausedUITimerId = null;
        this._pausedTimerId = null;
        this._timerForceEnd = false;


        // todo focus and blur


        window.addEventListener("pageshow", () => {
            debug('pageshow')
        }, false);
        window.addEventListener("pagehide", () => {
            debug('pagehide')
        }, false);

        // let storiesList = this.$store.state.stories.filter(_ => _),
        //     list        = []
        // storiesList.forEach(item => {
        //   list.push(item.id)
        //   this.storyActiveSlide.push(0)
        // })

        // this.updateDisplayedItems();

        /*this.$store.watch(
          (state) => {
            return this.$store.state.showStoriesView // could also put a Getter here
          },
          (newValue, oldValue) => {

            //something changed do something
            const html = document.querySelector('html')
            if (newValue) {
              html.style['overflow'] = 'hidden'
            } else {
              html.style['overflow'] = null
            }

            // debug(oldValue)
            // debug(newValue)
          },
  //Optional Deep if you need it
          {
            deep: true
          }
        )*/

        this._html = document.querySelector('html');
        this._globalWrapper = document.querySelector('body > .wrapper');

        this.lockVerticalScroll();

        this.initBaseHandlers();
        if (needSession()) {
            this.initStatistic()
        }

        this._viewportWidth = _winWidth();
        this._viewportHeight = _winHeight();
        this._viewportRatio = this._viewportWidth / this._viewportHeight;


    }

    ready() {

    }

    beforeDestroy() {

        if (this._backdrop !== null && this._body !== null) {
            this._body.removeChild(this._backdrop);
        }

        // fullScreenCancel();

        this.removeAllEventListeners();

        this.timerPaused = true;

        // const html = document.querySelector('html')
        // html.style['overflow'] = ''
        // html.style['height'] = ''
        //
        // const body = document.querySelector('body')
        // body.style['overflow'] = ''

        this.unlockVerticalScroll()

        if (this.screenOrientationLocked) {
            orientation.unlock();
        }

    }

    screenOrientationLocked = false;
    beforeMount() {
        this._viewportWidth = _winWidth();
        this._viewportHeight = _winHeight();
        this._slideRatio = 0.64516129032;

        this.needBottomPanel = this.items.some(item => {
            return this.hasLike(item) || this.hasFavorite(item) || this.hasShare(item) || this.hasAudio(item);
        });

        // this.initStoriesStyle();
        this.initStoriesScript();
        this.initDataFeature();

        try {
            orientation.lock(SCREEN_ORIENTATIONS.PORTRAIT_PRIMARY);
            this.screenOrientationLocked = true;
        } catch (error) {
            this.screenOrientationLocked = false;
            debug(error);
        }


    }

    __afterStartInitQueue: Array<()=>void> = [];
    mounted() {

        if (needSession()) {
            this._statistic = new StoriesStatistic(this.$store);
        }

        this.currentIndex = this.activeStoryIndex;
        debug(`mounted this.currentIndex: ${this.currentIndex}`);

        this.updateDisplayedItems();
        // this.refreshSlidesLinks();

        if (this._backdrop !== null && this._body !== null) {
            this._body.appendChild(this._backdrop);
        }

        this.initStoriesStyle();

        // чтобы начать загрузку слайда в этот момент (лоадер крутилка)
        this.$store.commit('stories/setNextFlippingStory', this.id);

        // todo если окно уходит из mainActivity - ставить на паузу
        const currentStoryId = this.id;
        // при старте share-page не ставит этот параметр
        this.$store.commit('stories/SET_ACTIVE_STORY', currentStoryId);
        this.waitForSlideLoaded(currentStoryId).then((result) => {
            if (result) {
                this.$emit('showStory', {id: currentStoryId});
                this.$emit('showSlide', {id: currentStoryId, index: 0});
                this.setTimer();
                this.slideStart();
            } else {
                debug(`slide don\`t loaded: ${currentStoryId}`)
            }
        });


        const rotater: HTMLElement = (<HTMLElement>this.$refs.rotater);

        if (rotater !== null) {
            rotater.addEventListener('transitionend', this.onTransitionEnd, false);
        }


        // готовим весь список
        const ids: Array<number> = [];

        this.items.forEach((item: StoriesItem | BlankStoriesItem) => {
            if (item instanceof StoriesItem) {
                ids.push(item.id)
            }
        });

        this.$store.dispatch('shared/FETCH_STORIES_SLIDES', ids).then(() => {
            // debug('all stories fetched')

            this.displayedItems.forEach(() => this.storyActiveSlide.push(0));


            // this.updateDisplayedItems();

            this.$nextTick(() => {
                this._slider = this.$el;
                this._innerSlider = (<HTMLDivElement>this.$refs['innerSlider']);
                this.init3DSlider();

                window.addEventListener('resize', this.init3DSlider);

                this.rotateSlider(this.currentIndex, true);


                if (this._slider !== null) {

                    /* Feature detection */
                    let passiveSupported = false;
                    try {
                        window.addEventListener(
                            "abort",
                            _ => _,
                            Object.defineProperty({}, "passive", {
                                get: function () {
                                    passiveSupported = true;
                                }
                            }));
                    } catch (err) {
                    }

                    this._slider.addEventListener('mousedown', this.dragRotationHandler, false);
                    this._slider.addEventListener('touchstart', this.dragRotationHandler, passiveSupported ? {passive: true} as EventListenerOptions : false)
                }

            });

            this.$store.getters['shared/loadedStories'].forEach((storiesItem: StoriesItem) => {

                const articleIds = storiesItem.articleIds,
                    issueArticleIds = storiesItem.issueArticleIds;

                this.$store.dispatch('article/FETCH_ARTICLES', articleIds);
                this.$store.dispatch('article/FETCH_ISSUE_ARTICLES', issueArticleIds);
            });

        });

        this.initSlidesAspectRatio();

        window.addEventListener('resize', this.initSlidesAspectRatio);

        (<any>orientation).addEventListener('change', this.checkScreenOrientation);
        this.checkScreenOrientation();

        this.$emit('openViewer', {storiesId: this.id});
        this.$emit('nextStories', {toStoryId: this.id});

        // this.$on('nextStories', () => {
        //     this.initStoriesStyle();
        // });

        this.__afterStartInitQueue = [];
        this.$on('showSlide', ({index}: {index: number}) => {
            if (Array.isArray(this.__afterStartInitQueue)) {
                for (let i = 0; i < this.__afterStartInitQueue.length; i++) {
                    if (isFunction(this.__afterStartInitQueue[i])) {
                        this.__afterStartInitQueue[i]();
                    }
                }
                this.__afterStartInitQueue = [];
            }
        });


    }

    /** Watch */
    @Watch('timerPaused')
    onTimerPausedChanged(to: boolean, from: boolean) {
        if (to === true && from === false) {
            this.onPause();
        } else if (to === false && from === true) {
            this.onResume();
        }
    }

}


